var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5AxSingleSingleTandem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3236.29 815.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266,.cls-267,.cls-268,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287{stroke-width:0px;}.cls-2,.cls-283{fill:#414042;}.cls-3,.cls-7,.cls-151,.cls-288,.cls-262,.cls-263,.cls-265,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-283,.cls-286{mix-blend-mode:multiply;}.cls-3,.cls-248{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_5);}.cls-6{fill:url(#New_Gradient_Swatch_3);}.cls-7{fill:url(#linear-gradient-5);}.cls-289{filter:url(#luminosity-noclip-6);}.cls-290{filter:url(#luminosity-noclip-2);}.cls-291{filter:url(#luminosity-noclip-4);}.cls-8{fill:url(#New_Gradient_Swatch_5-2);}.cls-9{fill:url(#New_Gradient_Swatch_3-3);}.cls-10{fill:url(#New_Gradient_Swatch_3-4);}.cls-11{fill:url(#New_Gradient_Swatch_3-9);}.cls-12{fill:url(#New_Gradient_Swatch_3-8);}.cls-13{fill:url(#New_Gradient_Swatch_3-7);}.cls-14{fill:url(#New_Gradient_Swatch_3-6);}.cls-15{fill:url(#New_Gradient_Swatch_3-2);}.cls-16{fill:url(#New_Gradient_Swatch_3-5);}.cls-17{fill:url(#New_Gradient_Swatch_4-3);}.cls-18{fill:url(#New_Gradient_Swatch_4-2);}.cls-19{fill:url(#New_Gradient_Swatch_4-4);}.cls-20{fill:url(#New_Gradient_Swatch_4-5);}.cls-21{fill:url(#linear-gradient-179);}.cls-22{fill:url(#linear-gradient-177);}.cls-23{fill:url(#linear-gradient-176);}.cls-24{fill:url(#linear-gradient-178);}.cls-25{fill:url(#linear-gradient-120);}.cls-26{fill:url(#linear-gradient-125);}.cls-27{fill:url(#linear-gradient-124);}.cls-28{fill:url(#linear-gradient-126);}.cls-29{fill:url(#linear-gradient-188);}.cls-30{fill:url(#linear-gradient-180);}.cls-31{fill:url(#linear-gradient-184);}.cls-32{fill:url(#linear-gradient-185);}.cls-33{fill:url(#linear-gradient-186);}.cls-34{fill:url(#linear-gradient-187);}.cls-35{fill:url(#linear-gradient-181);}.cls-36{fill:url(#linear-gradient-182);}.cls-37{fill:url(#linear-gradient-183);}.cls-38{fill:url(#linear-gradient-138);}.cls-39{fill:url(#linear-gradient-139);}.cls-40{fill:url(#linear-gradient-134);}.cls-41{fill:url(#linear-gradient-131);}.cls-42{fill:url(#linear-gradient-136);}.cls-43{fill:url(#linear-gradient-132);}.cls-44{fill:url(#linear-gradient-135);}.cls-45{fill:url(#linear-gradient-130);}.cls-46{fill:url(#linear-gradient-133);}.cls-47{fill:url(#linear-gradient-137);}.cls-48{fill:url(#linear-gradient-197);}.cls-49{fill:url(#linear-gradient-196);}.cls-50{fill:url(#linear-gradient-195);}.cls-51{fill:url(#linear-gradient-194);}.cls-52{fill:url(#linear-gradient-189);}.cls-53{fill:url(#linear-gradient-190);}.cls-54{fill:url(#linear-gradient-199);}.cls-55{fill:url(#linear-gradient-100);}.cls-56{fill:url(#linear-gradient-101);}.cls-57{fill:url(#linear-gradient-192);}.cls-58{fill:url(#linear-gradient-191);}.cls-59{fill:url(#linear-gradient-193);}.cls-60{fill:url(#linear-gradient-198);}.cls-61{fill:url(#linear-gradient-123);}.cls-62{fill:url(#linear-gradient-129);}.cls-63{fill:url(#linear-gradient-121);}.cls-64{fill:url(#linear-gradient-122);}.cls-65{fill:url(#linear-gradient-106);}.cls-66{fill:url(#linear-gradient-102);}.cls-67{fill:url(#linear-gradient-104);}.cls-68{fill:url(#linear-gradient-103);}.cls-69{fill:url(#linear-gradient-105);}.cls-70{fill:url(#linear-gradient-117);}.cls-71{fill:url(#linear-gradient-118);}.cls-72{fill:url(#linear-gradient-111);}.cls-73{fill:url(#linear-gradient-112);}.cls-74{fill:url(#linear-gradient-127);}.cls-75{fill:url(#linear-gradient-128);}.cls-76{fill:url(#linear-gradient-113);}.cls-77{fill:url(#linear-gradient-114);}.cls-78{fill:url(#linear-gradient-115);}.cls-79{fill:url(#linear-gradient-116);}.cls-80{fill:url(#linear-gradient-119);}.cls-81{fill:url(#linear-gradient-173);}.cls-82{fill:url(#linear-gradient-170);}.cls-83{fill:url(#linear-gradient-175);}.cls-84{fill:url(#linear-gradient-174);}.cls-85{fill:url(#linear-gradient-172);}.cls-86{fill:url(#linear-gradient-144);}.cls-87{fill:url(#linear-gradient-145);}.cls-88{fill:url(#linear-gradient-149);}.cls-89{fill:url(#linear-gradient-148);}.cls-90{fill:url(#linear-gradient-171);}.cls-91{fill:url(#linear-gradient-146);}.cls-92{fill:url(#linear-gradient-143);}.cls-93{fill:url(#linear-gradient-169);}.cls-94{fill:url(#linear-gradient-140);}.cls-95{fill:url(#linear-gradient-141);}.cls-96{fill:url(#linear-gradient-147);}.cls-97{fill:url(#linear-gradient-166);}.cls-98{fill:url(#linear-gradient-142);}.cls-99{fill:url(#linear-gradient-168);}.cls-100{fill:url(#linear-gradient-164);}.cls-101{fill:url(#linear-gradient-161);}.cls-102{fill:url(#linear-gradient-163);}.cls-103{fill:url(#linear-gradient-158);}.cls-104{fill:url(#linear-gradient-160);}.cls-105{fill:url(#linear-gradient-159);}.cls-106{fill:url(#linear-gradient-167);}.cls-107{fill:url(#linear-gradient-162);}.cls-108{fill:url(#linear-gradient-165);}.cls-109{fill:url(#linear-gradient-154);}.cls-110{fill:url(#linear-gradient-152);}.cls-111{fill:url(#linear-gradient-157);}.cls-112{fill:url(#linear-gradient-155);}.cls-113{fill:url(#linear-gradient-151);}.cls-114{fill:url(#linear-gradient-153);}.cls-115{fill:url(#linear-gradient-150);}.cls-116{fill:url(#linear-gradient-156);}.cls-117{fill:url(#linear-gradient-233);}.cls-118{fill:url(#linear-gradient-234);}.cls-119{fill:url(#linear-gradient-209);}.cls-120{fill:url(#linear-gradient-236);}.cls-121{fill:url(#linear-gradient-230);}.cls-122{fill:url(#linear-gradient-235);}.cls-123{fill:url(#linear-gradient-219);}.cls-124{fill:url(#linear-gradient-213);}.cls-125{fill:url(#linear-gradient-211);}.cls-126{fill:url(#linear-gradient-214);}.cls-127{fill:url(#linear-gradient-231);}.cls-128{fill:url(#linear-gradient-232);}.cls-129{fill:url(#linear-gradient-215);}.cls-130{fill:url(#linear-gradient-212);}.cls-131{fill:url(#linear-gradient-218);}.cls-132{fill:url(#linear-gradient-208);}.cls-133{fill:url(#linear-gradient-207);}.cls-134{fill:url(#linear-gradient-205);}.cls-135{fill:url(#linear-gradient-201);}.cls-136{fill:url(#linear-gradient-203);}.cls-137{fill:url(#linear-gradient-204);}.cls-138{fill:url(#linear-gradient-206);}.cls-139{fill:url(#linear-gradient-200);}.cls-140{fill:url(#linear-gradient-202);}.cls-141{fill:url(#linear-gradient-210);}.cls-142{fill:url(#linear-gradient-228);}.cls-143{fill:url(#linear-gradient-229);}.cls-144{fill:url(#linear-gradient-223);}.cls-145{fill:url(#linear-gradient-227);}.cls-146{fill:url(#linear-gradient-225);}.cls-147{fill:url(#linear-gradient-222);}.cls-148{fill:url(#linear-gradient-224);}.cls-149{fill:url(#linear-gradient-220);}.cls-150{fill:url(#linear-gradient-221);}.cls-292{mask:url(#mask);}.cls-151,.cls-285{fill:#fff;}.cls-152,.cls-263{fill:#ed1c24;}.cls-153{fill:url(#linear-gradient);}.cls-293{filter:url(#luminosity-noclip);}.cls-154{fill:#ef4136;}.cls-155,.cls-262{fill:#6d6e71;}.cls-156{fill:#f15a29;}.cls-157{fill:url(#linear-gradient-38);}.cls-158{fill:url(#linear-gradient-33);}.cls-159{fill:url(#linear-gradient-29);}.cls-160{fill:url(#linear-gradient-32);}.cls-161{fill:url(#linear-gradient-30);}.cls-162{fill:url(#linear-gradient-31);}.cls-163{fill:url(#linear-gradient-36);}.cls-164{fill:url(#linear-gradient-39);}.cls-165{fill:url(#linear-gradient-34);}.cls-166{fill:url(#linear-gradient-37);}.cls-167{fill:url(#linear-gradient-35);}.cls-168{fill:url(#linear-gradient-28);}.cls-169{fill:url(#linear-gradient-25);}.cls-170{fill:url(#linear-gradient-11);}.cls-171{fill:url(#linear-gradient-12);}.cls-172{fill:url(#linear-gradient-13);}.cls-173{fill:url(#linear-gradient-10);}.cls-174{fill:url(#linear-gradient-17);}.cls-175{fill:url(#linear-gradient-16);}.cls-176{fill:url(#linear-gradient-19);}.cls-177{fill:url(#linear-gradient-15);}.cls-178{fill:url(#linear-gradient-23);}.cls-179{fill:url(#linear-gradient-21);}.cls-180{fill:url(#linear-gradient-18);}.cls-181{fill:url(#linear-gradient-14);}.cls-182{fill:url(#linear-gradient-22);}.cls-183{fill:url(#linear-gradient-20);}.cls-184{fill:url(#linear-gradient-27);}.cls-185{fill:url(#linear-gradient-24);}.cls-186{fill:url(#linear-gradient-26);}.cls-187{fill:url(#linear-gradient-45);}.cls-188{fill:url(#linear-gradient-46);}.cls-189{fill:url(#linear-gradient-44);}.cls-190{fill:url(#linear-gradient-48);}.cls-191{fill:url(#linear-gradient-49);}.cls-192{fill:url(#linear-gradient-47);}.cls-193{fill:url(#linear-gradient-42);}.cls-194{fill:url(#linear-gradient-43);}.cls-195{fill:url(#linear-gradient-40);}.cls-196{fill:url(#linear-gradient-41);}.cls-197{fill:url(#linear-gradient-59);}.cls-198{fill:url(#linear-gradient-57);}.cls-199{fill:url(#linear-gradient-58);}.cls-200{fill:url(#linear-gradient-55);}.cls-201{fill:url(#linear-gradient-56);}.cls-202{fill:url(#linear-gradient-53);}.cls-203{fill:url(#linear-gradient-51);}.cls-204{fill:url(#linear-gradient-52);}.cls-205{fill:url(#linear-gradient-50);}.cls-206{fill:url(#linear-gradient-54);}.cls-207{fill:url(#linear-gradient-60);}.cls-208{fill:url(#linear-gradient-61);}.cls-209{fill:url(#linear-gradient-62);}.cls-210{fill:url(#linear-gradient-65);}.cls-211{fill:url(#linear-gradient-79);}.cls-212{fill:url(#linear-gradient-78);}.cls-213{fill:url(#linear-gradient-77);}.cls-214{fill:url(#linear-gradient-75);}.cls-215{fill:url(#linear-gradient-76);}.cls-216{fill:url(#linear-gradient-74);}.cls-217{fill:url(#linear-gradient-67);}.cls-218{fill:url(#linear-gradient-68);}.cls-219{fill:url(#linear-gradient-66);}.cls-220{fill:url(#linear-gradient-63);}.cls-221{fill:url(#linear-gradient-69);}.cls-222{fill:url(#linear-gradient-64);}.cls-223{fill:url(#linear-gradient-71);}.cls-224{fill:url(#linear-gradient-72);}.cls-225{fill:url(#linear-gradient-70);}.cls-226{fill:url(#linear-gradient-73);}.cls-227{fill:url(#linear-gradient-84);}.cls-228{fill:url(#linear-gradient-85);}.cls-229{fill:url(#linear-gradient-82);}.cls-230{fill:url(#linear-gradient-83);}.cls-231{fill:url(#linear-gradient-89);}.cls-232{fill:url(#linear-gradient-88);}.cls-233{fill:url(#linear-gradient-86);}.cls-234{fill:url(#linear-gradient-87);}.cls-235{fill:url(#linear-gradient-80);}.cls-236{fill:url(#linear-gradient-81);}.cls-237{fill:url(#linear-gradient-98);}.cls-238{fill:url(#linear-gradient-91);}.cls-239{fill:url(#linear-gradient-92);}.cls-240{fill:url(#linear-gradient-93);}.cls-241{fill:url(#linear-gradient-90);}.cls-242{fill:url(#linear-gradient-96);}.cls-243{fill:url(#linear-gradient-97);}.cls-244{fill:url(#linear-gradient-94);}.cls-245{fill:url(#linear-gradient-95);}.cls-246{fill:url(#linear-gradient-99);}.cls-247{fill:#3c2415;}.cls-249{fill:#58595b;}.cls-250{fill:#bcbec0;}.cls-251{fill:#808285;}.cls-252{fill:url(#New_Gradient_Swatch_3-12);}.cls-253{fill:url(#New_Gradient_Swatch_3-11);}.cls-254{fill:url(#New_Gradient_Swatch_3-10);}.cls-255{fill:url(#New_Gradient_Swatch_3-14);}.cls-256{fill:url(#New_Gradient_Swatch_3-16);}.cls-257{fill:url(#New_Gradient_Swatch_3-13);}.cls-258{fill:url(#New_Gradient_Swatch_3-15);}.cls-259,.cls-266{fill:#000;}.cls-260,.cls-265{fill:#a7a9ac;}.cls-261{fill:url(#New_Gradient_Swatch_11_cop);}.cls-264{fill:#be1e2d;}.cls-266{opacity:.5;}.cls-267{fill:url(#linear-gradient-4);}.cls-268{fill:url(#linear-gradient-2);}.cls-269{fill:url(#linear-gradient-3);}.cls-270{fill:url(#linear-gradient-8);}.cls-271{fill:url(#linear-gradient-9);}.cls-272{fill:url(#linear-gradient-7);}.cls-273{fill:url(#linear-gradient-6);}.cls-274{fill:url(#linear-gradient-217);}.cls-275{fill:url(#linear-gradient-216);}.cls-276{fill:url(#linear-gradient-226);}.cls-277{fill:url(#linear-gradient-110);}.cls-278{fill:url(#linear-gradient-109);}.cls-279{fill:url(#linear-gradient-108);}.cls-280{fill:url(#linear-gradient-107);}.cls-294{isolation:isolate;}.cls-281{fill:#e6e7e8;}.cls-282{fill:#c49a6c;}.cls-284{fill:#d1d3d4;}.cls-286{fill:#939598;}.cls-295{mask:url(#mask-3);}.cls-296{mask:url(#mask-2);}.cls-297{mask:url(#mask-5);}.cls-298{mask:url(#mask-4);}.cls-299{mask:url(#mask-1);}.cls-287{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 1946.12,
    y: 712.71,
    width: 1290.16,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 1946.12,
    y: 712.71,
    width: 1290.16,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1291,
    height: 88,
    transform: "translate(1945.67 712.15)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1637.45,
    y1: 577.92,
    x2: 1745.78,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1701.48,
    y1: 588,
    x2: 1745.78,
    y2: 588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#322f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 567.85,
    y2: 567.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1756.37,
    y1: 577.92,
    x2: 1996.72,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1756.37,
    y1: 577.86,
    x2: 1996.36,
    y2: 577.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1992.72,
    y1: 573.03,
    x2: 2297.75,
    y2: 573.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#302f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2024.03,
    y1: 540.83,
    x2: 2024.03,
    y2: 510.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3f3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#393739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e2c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1998.78,
    x2: 1998.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2032,
    x2: 2032,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2258.83,
    x2: 2258.83,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2266.8,
    x2: 2266.8,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2291.89,
    x2: 2291.89,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 2170.52,
    y1: 713.67,
    x2: 2170.52,
    y2: 526.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 2170.52,
    y1: 543.79,
    x2: 2170.52,
    y2: 702.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2170.52,
    y1: 678.45,
    x2: 2170.52,
    y2: 563.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2170.49,
    y1: 569.83,
    x2: 2170.49,
    y2: 670.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2170.52,
    y1: 638.92,
    x2: 2170.52,
    y2: 601.67,
    gradientTransform: "translate(402.68 -783.39) rotate(22.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2170.52,
    y1: 634.04,
    x2: 2170.52,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1268.27,
    y1: 10043.29,
    x2: -1268.27,
    y2: 9864.6,
    gradientTransform: "translate(-7404.63 -698.89) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1246.35,
    y1: 9861.62,
    x2: -1246.35,
    y2: 10046.09,
    gradientTransform: "translate(1394.48 10592.93) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1391.91 10590.35) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 9861.63,
    y2: 10046.09,
    gradientTransform: "translate(1388.73 10587.17) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1384.9 10583.34) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1380.4 10578.84) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1375.36 10573.8) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1369.78 10568.22) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1363.73 10562.17) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1357.05 10555.5) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1350.13 10548.57) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1342.69 10541.13) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1335.04 10533.48) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1327.02 10525.47) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1318.91 10517.35) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(1310.68 10509.13) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3703.9 -9314.72)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3706.48 -9317.3)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 9861.62,
    y2: 10046.1,
    gradientTransform: "translate(3709.66 -9320.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3713.48 -9324.31)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3717.98 -9328.8)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3723.02 -9333.85)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3728.61 -9339.43)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3734.66 -9345.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3741.33 -9352.15)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3748.26 -9359.08)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3755.69 -9366.51)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3763.35 -9374.17)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3771.36 -9382.18)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3779.48 -9390.3)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 9861.62,
    y2: 10046.09,
    gradientTransform: "translate(3787.7 -9398.52)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -1246.35,
    y1: 9861.62,
    x2: -1246.35,
    y2: 10046.09,
    gradientTransform: "translate(3795.54 -9406.36)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1290.19,
    x2: -1290.19,
    gradientTransform: "translate(1350.65 10636.76) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1348.07 10634.18) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -1290.19,
    y1: 9861.63,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1344.89 10631) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1341.07 10627.18) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1336.57 10622.68) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1331.53 10617.64) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1325.94 10612.05) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1319.89 10606) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1313.22 10599.33) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1306.29 10592.4) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1298.86 10584.97) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1291.2 10577.32) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1283.19 10569.3) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1275.07 10561.18) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(1266.85 10552.96) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3747.74 -9270.89)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3750.31 -9273.46)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.1,
    gradientTransform: "translate(3753.49 -9276.64)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3757.32 -9280.47)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3761.82 -9284.97)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3766.86 -9290.01)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3772.44 -9295.6)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3778.49 -9301.65)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3785.16 -9308.32)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3792.09 -9315.25)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3799.53 -9322.68)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3807.18 -9330.33)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3815.2 -9338.35)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3823.31 -9346.47)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3831.54 -9354.69)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -1290.19,
    y1: 9861.62,
    x2: -1290.19,
    y2: 10046.09,
    gradientTransform: "translate(3839.38 -9362.53)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -1268.27,
    y1: 9863.12,
    x2: -1268.27,
    y2: 10046.59,
    gradientTransform: "translate(3817.46 -9384.45)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 3060.96,
    y1: 604.79,
    x2: 3060.96,
    y2: 541.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#353436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#171617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 2832.03,
    x2: 2832.03,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 2946.76,
    y1: 546.43,
    x2: 2946.76,
    y2: 552.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 2946.76,
    y1: 552.3,
    x2: 2946.76,
    y2: 558,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 2946.76,
    y1: 558.16,
    x2: 2946.76,
    y2: 563.61,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 2946.76,
    y1: 563.92,
    x2: 2946.76,
    y2: 569.25,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 2946.76,
    y1: 569.35,
    x2: 2946.76,
    y2: 575.12,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 2946.76,
    y1: 575.33,
    x2: 2946.76,
    y2: 581.32,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 2946.76,
    y1: 581.63,
    x2: 2946.76,
    y2: 586.63,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    y1: 586.85,
    y2: 592.06,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 2946.76,
    y1: 593.04,
    x2: 2946.76,
    y2: 598.15,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 2946.76,
    y1: 598.91,
    x2: 2946.76,
    y2: 604.02,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 2946.76,
    y1: 604.56,
    x2: 2946.76,
    y2: 610.45,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 2946.76,
    y1: 610.86,
    x2: 2946.76,
    y2: 615.75,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 2926.83,
    y1: 546.38,
    x2: 2926.83,
    y2: 622.59,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 2966.7,
    y1: 546.38,
    x2: 2966.7,
    y2: 622.59,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 2828.26,
    x2: 2828.26,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 2828.26,
    x2: 2828.26,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 2828.26,
    x2: 2828.26,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 2828.23,
    x2: 2828.23,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 2828.26,
    x2: 2828.26,
    gradientTransform: "translate(452.75 -1035.1) rotate(22.5)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 2828.26,
    y1: 634.04,
    x2: 2828.26,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 3064.96,
    x2: 3064.96,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 3064.96,
    x2: 3064.96,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 3064.96,
    x2: 3064.96,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 3064.93,
    x2: 3064.93,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 3064.96,
    x2: 3064.96,
    gradientTransform: "translate(2964.68 -2505.02) rotate(76.72)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 3064.96,
    y1: 634.04,
    x2: 3064.96,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 3211.16,
    y1: 515.13,
    x2: 3211.16,
    y2: 561.99,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 3222.02,
    y1: 600.45,
    x2: 3222.02,
    y2: 617.46,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 3210.55,
    y1: 480.76,
    x2: 3210.55,
    y2: 634.21,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -9151.95,
    y1: 3908.98,
    x2: -9151.95,
    y2: 3927.42,
    gradientTransform: "translate(-5919.84 4468.22) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 3232.12,
    y1: 517.67,
    x2: 3232.12,
    y2: 537.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 3162.8,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 3162.8,
    y: -10178.15,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 3162.8,
    y: -10178.15,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 3171.81,
    y1: 541.26,
    x2: 3171.81,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 3162.8,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "3169.96 541.26 3162.8 541.26 3162.8 486.41 3180.82 486.41 3169.96 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 3171.81,
    y1: 541.26,
    x2: 3171.81,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#767474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 2712.8,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 2712.8,
    y: -10178.15,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 2712.8,
    y: -10178.15,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -9081.3,
    x2: -9081.3,
    gradientTransform: "translate(-6359.49) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-107"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 2712.8,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "2723.66 541.26 2730.81 541.26 2730.81 486.41 2712.8 486.41 2723.66 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -9081.3,
    x2: -9081.3,
    gradientTransform: "translate(-6359.49) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2624.72,
    y1: 1.28,
    x2: 2624.72,
    y2: 480.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -10640.73,
    y1: 492.02,
    x2: -10640.73,
    y2: 477.08,
    gradientTransform: "translate(12671.63 968.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -10659.9,
    y1: 476.94,
    x2: -10659.9,
    y2: 492.69,
    gradientTransform: "translate(12709.98 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -11224.95,
    x2: -11224.95,
    gradientTransform: "translate(13840.08 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -11244.13,
    y1: 476.94,
    x2: -11244.13,
    y2: 492.69,
    gradientTransform: "translate(13878.43 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -11809.18,
    x2: -11809.18,
    gradientTransform: "translate(15008.53 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -11828.35,
    y1: 476.94,
    x2: -11828.35,
    y2: 492.69,
    gradientTransform: "translate(15046.88 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 0,
    y: 722.18,
    width: 1655.61,
    height: 93.34,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 0,
    y: 722.18,
    width: 1655.61,
    height: 93.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1656,
    height: 94,
    transform: "translate(-.33 722.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABngAAABeCAYAAAAAJBq6AAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nO3d25ajxrKF4dC5u+31/s+4r9ay2+7SWfvCnlQQygRUQiKB/xtDo1QIECRIhTQrMhdmdluv16bbZrOxLr+vVqvq/mazsdVqVU3XbbPZ1Obxjy+Xy9oy+qnp8bHlclk95ufR710eWywW1e/+Fh/7+Piolr/dbrX9X6/X1eN6TPu23+9tuVxmn0fTD4dD1Tb7/b6avlgs7m5++sfHR+25XmWxWLxs3SVhP6dlDvs5h300Yz+nZg77OYd9NGM/p2YO+/nXX3+9dP1zaEMz9nNq5rKfZvPZV/Zzeuayr+xnf379+vX08756/nc8B/P3P//tdqt+z93/+fNn7Xvz2+2WvGk53X7+/FnLAK7Xq12vV/vzzz9r3/Ffr1e73W53Pz8+Pmrb6r8r97/rvp/mt3+/31e/x/t+mr/t9/tqO/T49Xq1w+FQ3T8ej3a5XOx6vdrlcrHD4WCXy8Uul4sdj8dq+vV6rdanZc7nc/J2PB7tdDrZ+Xy20+lU3V/7HV8ul1Vj6knW639mWS6Xdj6fq0ZYLBZ2uVyq8EE7qGXjgdP6NpuNnU6n6iBtt1szs1qYo+f7/v27Xa/XWph0uVxsuVzajx8/7HQ6VY9tt9tqvb///rsdj8faYz7sORwOtlwubbvd3j223++r7dxut1UIo3n2+/3dY9qOj4+PbIAUp+33ezsej/bx8XEX5PgwKBXyrFYr+/vvv7MvvjEZ2/aasc3vMLbtNRvfNo9te83Gt81j214ztvkdxra9Zu/d5uPx+NTyr97WV65/zNv+6vV/dd0/f/7sdX1DYpvfg21+D7b5Pdjm92jb5tQX7wAwBv/5z3/MrB6GxN91/7///a+Zmf3+++/JMCcV9JiZ/e9//6s9dr1e7cePH9V0ZQzxdr1eawUhCkeUXywWiyoUWSwW1WO+OEM5h+bT/cvlYrfbrVr2dDpV+3s+n+12u1UhjHIQLXe9Xqv5tO1av19O95WXmFktj/H5Stxv/1PWalQtuFqtagdNIY6Z1VI4P93snz9qPhxaLpdVGnW9Xm2z2VQbuF6vq4a9XC622+2qxrvdbrZarex0OlXzqtG1fUrpdF8HQdvz69evKuE7nU5VKKR9Wy6Xdrvd7HA4VKHQZrOx6/Vqi8XCfv36Vc2vKh2FT+v12v78889apZDuKziK03Vf++yDn7///jtb6RMDKT89F/C8SgkXWkNvw9DPX8I2DP38bEMZz1/CNgz9/HPehr4rSEtoRylpW8zYniYlbYtZWdtT0raYDbs9r67giUpoe7aBbWAbum/DK3vFAABgalR143+Pj+tnU/WO1uEf//HjR3X///7v/2oFE/E5tL7z+Wyr1ar6e66gRfP5kEWZxO12s9PpVMtCVFWjShotr2qcWPXj51PVjplVlTm6r0xC69b2+DDI31c2oozFb6Nunr++WWuCJvqdUxASU6K4jHbSl1OZmW02m1rIs9vtquBGB+hyudh+v6+CHB+I+IOz3W6rAGa5XNq3b9+qA6nuznwFz19//VV1n7bdbrPhibpn0/4ul0v79etXrWu5P/74w378+FElfakARxU8viTNhz7xeTXNh0lxXamqHt0eDXhecWHd9zrHsI3PrtOnvq9WwoepZ4x5+8e87WZs/5DGvO1m497+MW+7Gds/pDFvu9m4t79t23MVPF9d31eMYZ0lbuM7r5mn7Pv379nH5nAedVnno+8TAADMSQx1NK3L77E7Nj8t9bhyh99++83++OOPZAWPX+779++1HskOh0OtpzF9J6/HVquV/fr1q1pGXZ75Xst8NY+qbVTk4it2fHCj2+l0qsIe33WbAqbj8VgFTwqZtA6FQfqp5/XPE4OqWk5jZjdfnZIbGyd1f7PZVKGMfr9cLrVql+12e9f9mu+ybLPZVNO0jMIWdaHmS64UdGgdCobiWDp63Acr2j4dbIVEi8WiConU2D5Mabr54EUB1CPL+JPPzGrzxd/9tK7/bfToRXFJ85e0LX3O/87/FBvzlzZDoc2+hnb7GtrtcbTZ19Buj6PNvqakdvP9cjcZyzXk3ObvevwAAADwGt+/f78b7yaKAY+fFn82TWvr0k03BTfKHRTIKCjRtaWqaRSq+B7JVIDiQxNV5mh5PwaPmVUFIqoC8pU3MfyJXbepwEX748ft8QGPblrOLx+nabyey+XyOQZPbGCFFQpAtBOxURXIqFHUjZtvWIU+qrjRvOqiTSGP1q3KIfWf57dB4YgqenRAfQVPHFsnVaWjkES/q3HUlVrXgEe34/Fo3759qw54/JmaZmZ3pWaS+6BzPB6rwAwAAAAYs9QHwq7agoRnx3RCv0oK/9ANx2ycOG7jwzEbH45Zsz4qcftq45LWU9K2dFnP8XishRu5ZRWY6Lv/LvxnAOUHfnrqp76v13Ou12s7HA5VLqEiCr/9KshQpY560lJOECt4/Bg5vjs3M6tCodhFm++WLa5HyykYUuij9fppPjiK4U4Mj7Q+qcbgUYKlMXD8QdKT6Hcf6PiQR4mYyp8UyKg65nA42G63q6qAzD4HJ0p1oabn8etQiHM8Hqtp2mGNmaPGUGWOtkUVQkrzfvvtNzscDlX3a74LtlyQo2Wbbv5ET03TSbtYLGy329XaOsVX+ugE9csBAACgf10/oKQM/cF/yOcvZd/VRcK7nxfDoP2HQ9sPi/YfDm0/rK+2f9d/ABn6+M75+ee87yU9fwxM4vfbZlZ9T68gpUu4FwsrtJ5cZY9es7FdVMmjHOJ4PNpqtaqCGx84qfLHV+BoiBkNL6N5Yij08fFRbatyDD+mjg9dfBDje3BS129+XCB/Xz2KxcoibW/sDi5WOCUreHxXY74/N82jIEVPoJBH4Y6Cou12W22w2T/VKj7t8v3gffv2rTooej41pBrQh1Ba736/r8bLSVXwqCpntVrZ6XSqbaP63fv161dVWaTnimPe+JvvVu2RcCcmjf5xL6aNTY8DAID5eiaA6MsYr0vY5vcYepunXMEzdNtOBe34PNqwH7Tj86bShkOPQTbGdhzjNpux3e/Gdj8uBiu5n/77+1wYE/niB/9cZukK/9x743q9roIUBTQa/0bfuytA8WGNCktiBY+vptFyCl/i2DfKN/ScsSLHzGrhj+bz1T2+6ziNweMDHv94KuCpelRTA/ibgh3xFS1+foU0qupRVY4aSUmaxrbxY+GossaPx+Pva32Xy6UKf3x1j55bwY2CHDW+H1tHwZC6ctO2bLdb22w2tbF7tO9dq3W6hDw+mdS0eKI3BT0xMQUAYCyG/pBqNt6L+a9gX6eJff2aWMEzp3bsgvb4RFvU0R51tMeneF03t7Zhf6drTvtqxv5OXV/7mxs33n9f7qf7gCduR+ofE5sKHGKXban7KvTweUCs5lE+4Ls8Wy6Xdjgc7ip4dD+GNaouipUzmp7qxs1XHvme0Pz4OX6dCnj88/uu2LScD5buumhTw/gKHt/YqmrR2C9qLAU62+22Gp9H4YjWoRRss9nUwiA/1o4qe3y1jQIeH/z4gEfPsdvtqml+Hh9U+ZNOYY9KpXSy7na7WhDz7du31mqdtnDHp5G5qp5csJMLdeb2pgTMWSn/ecz7TjPapx1t1I42akcbtaON6l79d3Sq7T3F/ZriPplNc7+e2Sf+qWQ8aKduaKduaKd2tFE3tFNd7EpNYYlZczWPn9bU44Rvb30P7seWaft5OBxsu93WumHzw8zEEMV3hZa6+TDH9x4Wp2ndPrTRd/n++VQtZPZZGeS7ZUuNvaMswwc7MdSJ22IWumiL4YxvOIUmPnVSFc3hcLirgrlcLrZer2vJ2el0qoIejcOzXC6rg7Je/7M5Pn1T+OPDm/P5XKv2yY3fs91ua12tKUDS7/7+z58/bbVa2WazqUq54skW7/vlNc1X7Php8aTPrZcu2QB4JXxQLRXvja9Bu74Obfs6tO1rjL1dS/hHidLbsOTtK3nbzNi+Z7xy27h2ziv5nBg72va1aN/Xon1fa8zt6wOeXBdsuYDH3/zf5lT3a2ZWhSN+Hh9i5B5TJU6q27J4XwFLXIcfXsZ3z6b7/jOFr+aJVTl+/B0VwvjpPnDyFTkKfVI3zZOqIPLtszazxS3Run6MHL/hOqixwkYVPefzuaroUSC0Xq9tvV5XO6f1apn9fm/L5bI2Dk/srk3VQz5sihU9fvyfVJATpylh2+121Ul6Op1su902VtzopvaQj4+P6n48wXP3/QsgNV9u2pjfIDAtJXx5YsZrokQck7JwPMrC8SgLx6M8fRyT2EVbn+vu4h3PM6V9edfzDLkvJVw3835XJo5LmTguZeK4lInjUp5nj4m/lm77flv3FfDELsRib2FxO/38voexGMaoezgzy4Y1sQs1v87Y9ZsPcvz6faXP+XyucgQf0Gj7YuWO5tM4QL5rNT3mx+3x030w5H+PIVakFr35Bk5VuPhpZlZV58TwRGPbxOqa9XpdrUNVMnGe3W5Xq+zRTz1Xapv8c6lCx4/1E5dRuZNCHR0kP58Cnrabbyt1Q5d78ag7u3gC4z1oa0ScE0jhvEAK5wVSOC/Kx3/yP47zGjmcG8jh3EATzg/kcG6UTz1x+VDFS02LvYJ1ecwHMf7x3E+FHj6siRUtPrDxv/vu3Pxz+7AljoMTA5wY5OgfePR86upNOYTCIFX2+PDJV+j4fwRKBTupwKs6Fmq7eHB8iKFQx4c8qa7R1E3bYrGoqnZUuaN5FcjELt302Gq1qqp1tJyv7InPv1gsqvAkPq5QSaGOniMV6vgQaLfb1fa36aYqIAVXvg1jmzbdb5svdlPHGyEAAACQ19TnN/L4nIHScY6idJyjKN0cztGu14F9tsXU1pVqw1wXa10f1zy+osc/Twxz4n0/rw9nNF9qvJzYFZvaw8+r8MSHMApX9vv9XQjkK3iOx6Mtl8taMPTx8XHXpVocfyc+lyqmVNFkZrVu2hraeXEX8Hw+ku9OzMyq6hofqKQqeGKIojF4YqWN1r/dbu12u9W6aPMBT+6Wqu7RdipkivPkum7zFTzarqZgxwc8fYQ5uWWU3plZ1WYAAACYLv/h51VK+5Df1/YQ8JSvtHMP08L5hVfjHMOrdTnH3nG9U9q5zvY0e9W1dJfwpm0+/912fJ5cqKP7ueobP02BS6riRp+rVqvVXbjjw5oYymhabv1+bB+FP76qR9vqAx/fRVvsIi62Za5bNmexzj2SWtBP8+PxqMs1JUyxykaVNNpJH96oUWNgpOdYLpdV9Yp/XI99+/YtWVWkdWgwI7+cApm4zU03M6tVA+Ue9z+rVu4Y4PgUsW2Z0t48AAAAnpW64H+1KV1TTWlfzJ7fHwKe+ZjauY9+cX6gCefHuAxxrdinqZ1v7E/5ntmnVPDyleXbpLpV9t2p+W2I1TpmVuvmzAcvqZt6yVKo4ytptM0+bImhi19WmcPxeKzu+6ocZQ6+ekePKQPwXbbl3t+6tH824GlakU4O3zedr2JRaZLG01FFzuVyse12e7dun6IdDodad27ayRjs+IAoFfD4oCiGMb4rua63VMVOUxjk2yl3XyfqI2EOAQ8AANPQdMHL3/k62qOO9qjLtcczY/DQxtPFsZ02ju90ze3YdvlidG5t0gVtco82uUeb3Eu1SR/jWXZ5L2vqCk6Bi5/mq2L89/apbtk0Bo7EMMhX0Wid+ukrcpbLZVWp48Mh35WaHyMnVuzESh0/1o/fp7j/XSngWViim7YcPYmvgtFPBSHr9brWEApclE6t1+tkIONvGoPneDzabrerjT2jdcexaXwIpC7T/C1W8Whb5dEwp6mSp8v9Z0IeAADGYmz/bcff2n7Rnv2iPbspqYKHY1Yujk25ODbl4tj0a2zXyU04N16Ddu0fbdrumWvppmVjeKGgJvIhSwxkfDfWWl8uvPHbEwMjX6HjK2t8kOO7ZPNdufmu3/z90+l0132cD3f8/bgtX7Aw61jBk+MbUCGPwhY1joIclSUpZFF4oy7cchU4qTF2/Pgzfp7Y/ZsPdfRTQZSf5gMos8/gyu9nDHBy92st/O8J4X+P8z0S5lC9AwDjMKUPaSXi72B5OCZl4Xj8o6SA56s4lq9Bu74G7dpuLteInAtl4riUieNSJo5Lt2vp+HetKaTIPabnUWiTCz7izxiU5G4+1PFVSb4bNh8c+a7ffNWOD3O0vX66xtXROnQOXS6XWoikIMrv87OeCni8GPYsFv90hearYXz3bepeLVbcqCEUxsQu2WJQFH+qkbRcDHlUQZRaVj8VIMVAZbVaJafnfup+15CHYAfAGL3yCzTe96aHYzotHM/pmdIxnULAkzOl49Qn2uXeUG0ylyCjJJz/08WxnS6O7TRN5bjmrqXj/qXGyvFywY4PavSdfRz3JwYhviespkqYXLWM39ZUhdD5fL7rXi2GQJrmx+FRD2Y+9PHVQbGNnqjYSfIBz0PdtKXEqpdqxf92g3Y6naoxebSz/neFMhqnR5UzPqyJFT0+7FGXbLlgx99Pde0W54lVOr5rN03X9pv9M35Q5OfX733fB/A+U/6y6BG8B8HjfEDEOYFoiHNiin+zp/ramuJ+sU/TfA1+xRTPBfSDcwM5nBvIeee5EbtOi/d9VYo8c1/0TyK5Sh49nupuzc/ngxnftdpqtao9ppBGgYwKSDTtfD7fdf+m586FO34sn9S+9S2eFf1FR5buvsx32ea7ZvNBix87x4+P47tfy900z3q9zgY8bQFQauyeGPYo8PHT9Jx+/2N7pNqoy7Q43bcLnlfahw/+mKNvnFPoG+cU+sY5hb61Xd+VeM6Vvk2lVGWU2E6YDs4vvBLnF16J8wt9UmWNWb13qVhlE3Wp4vG/56p2Uj/9tagPmFLj6uTGyNF8MaTR/ePxWKvM8UPTpNbrwx3d98GOf86eVS/4l6YEalT/BnM+n++6WttsNlWXbLFbNs2/2+2S/eil+qpTo26322pdmq4DokDHj6/jn9esHubkbr5LulRXal0rcN75JlxamDEG/JFEaTgnURrOSZSGcxJdrnn7Pk9ecd6Vto2xXXmtoWScnygd5yhKxvk5b49+fxwDmC58uKJ1pH767fGVPKkKn1Tljh8bx09PPe6nKQjy86fWoXAnhkh9jbHTJgY8T3fTlhL7lbvdblW4Uj3xv0FPavwd30Xber2+C4JSwZAOgA9dVGGT6nIthk6pip2mYKepK7b4u5Y1+6zEebS6J5bJPeoFqeGk0V5AMy78AACl6XL9xjXe82hD4DW4vgYADKmtK7U4Td+pdw15FH74LtniuvUzVeWjaXGcnVRxiH76eWOQo3Anzu8Dnhgu+W7c/HLvrnofpJ8vNZa6U/NBjLpZi+PvqJJHv6sbtVTY4wOhXKDTFPZ0CXJyN7NuVTs60DqZV6vVQxU+XOwBAADg1UrpkusrVqvV0JsAAAAwW6VcR5b2HepYtueR4+eHMWlbLs7jK3HM7oMeP/6NpvlQRWPmxFAnTovj7cRwxwc2x+MxGQr5rtvidsRqpBerHbRBB3JRQy8WC1utVrXGUQhj9pkA+uocH/Ro/lzVT6oixwc32+229li8KYDqGvBoXf6+X4d//CtduF0uF8bgAQAAb0UXrwAAAMBj/DV0aV/s9439Gz+/jzp32/bbf8eu33PrTD0eP2fGbtlS4Y4eWy6XVTiTmj+GPKlqH199owDHV+j49ZvZXRjku2kbqrI9dYTeuiW+csd3labbarWqwgwFPJquCiAFPX5ZX+XzyE1hj68iaqrU8TdVBcV9E59m+uX1fLlQx3fpJvxHIgAAeLdS/gsP6ILrZQAAUIJ3jMMxh/Chb7RZM//ZL9dW/tyOlTmpZeLnyThuTy7ciVU4KvSI8/lAJ1epk6vs8YGOApvT6VTbdl8dFLtze7PWCp6XjMOTo4OhKh2Nz+PDD3XnJgpf/KBFWs533ZYLZ1Ldt+m23+9rYU9TqBN/j+GOTtBU1c6jFTy+GzsAADAsgg4AAAA86l3XkHx/NDyOwbBo/+e1hTUx3InLtVXuxPF1YvWQD2A0v+6riiY+rudJBTwKbNTzl38ezevDHT9GUKoKaMBw504x/Xz5g+EPqIKf1Py+O7f4+2azsdPp1DncaRuzx4c9ZumwRr83BTtxmS4BT+6FAQDA0Ag6AAAA8IixXT/yXcz0cEyniePar6aAJ4YasXu21Py5cXbiMgp8UmPupAKfVPATq2t8EHO5XGoh0PF4rM0Tx9OJgY6mDejuRC8m4DGrJ21mn92W6QCrMRXgaJwdjcvjx+C53W622WzMzGrhjQIg3yWcmdXCnDivKnu0jKqEJBXg+G7VugQ9fnqqS7Y4DwCgLGP7oAoAAAAMpUvXP4DHeYI2nCP9yr1P58Idv1z8jjwX7vgu1xaLRS048eGKfo+BTip8yd33FTp6TD1m+UAndtmmffaPlabpzB9mVKB/+fAjjq2jsW4Wi0UVAvnARvd3u11tXT4wyt2aum/LPa4xgsz+CaV81VHXn3EMnlzI4+cHgKGU+AcNAACP62UApRv6mpovQ/FunHMYAufd16SqcdrCHT9PDHdy3a35wCc1bk4q2IldpqWqdXzIo/3xgdD5fLblcllbXmPr+GW1DwqD/PYO5K7Riw14RBU2MeTx91VRk5pnvV7fhTI+IHo28Emt16xb12v+vg942v6TRWEVULqhP7AAAID54noZY8J183zxxSOmgPMYU8B5XBcDni7hjuaL33GnKnjimDlNIY6f5rtqa6rWieP4+GkKa/xz+8ficrEKaUDJRm/qom1hBYQ88eRR92sKXszMjsfjXWWP715NJ5aW8d28tYU2fj1t4U/uRFdIlXpM2ip2gLHiwyoAAAC64LoRpeBzOJDGawNIm+JrIxdqNO2rvt9OVeeY1b/n17wxmNFyuWl+21LBjr+ejBU9Gn9nsVjcBTp+nKA4Jk/p2s6+wQMeL3Zn5rtl86GL74rNhz6pahxNW61WD1XrNHXVlqrSidPaXvhtj/tu4TAOfGAFAAB4Hyp4xolrZjxqil+qASXitQa8RymvtfP5bKvVKnttpjAkfvftA5EY9PiARsv4sEbzpIIe/Z4bd0fP64OeOI+KRBT05Naj5ylM9sTocsYUFfKY2V3Ikgp6NptNbX4/Nk+qK7emLt2e6aIt9/N6vVZB1PV6rVX55F7IhZSCAQAAAJiwUr5YAIBX4/0OwFw8+n4Xg53U8rkKnTjd/x7X67txS4U7qS7cUoGMX0bj6vhKHB/YxHAnVvgU+h38tAIeM7sLanLBTW68HV/lk1qPf7zPgCcGO9qW3D427T8AAAAwZY98uEp1gYz+8TkEQGl4XwKQ8kjXWiW8j5S2Dalr6dQ2qp31/bhfLl7Lx3X6LtWaqnhSXbL5yptcNY7/eTqdkmPy+G3T/AVqPDm6njlFhjxm7UGPQhc/rSm8ievKBURNoZG2y99X/36r1aoKdvzjfkyhHP+CSY3rAwAAgGkq8b/ISvgQ2qTQD2fAW5T++gRQBt4rMHUlXkNL6a+/tmtp3yuVvuvWcql2zwU/vmKmrWrHBzh+/lTXbXEcHT2eqwLqss8DajxZRj+Qiw6EDz18gOIHbFLAcrvdsuGMHlPgcjqdOgVDMbDRT50YCnb8Ce+XSWlKRQEAwDx9pSqh9A8PY0Jb9uuV7VlKBQ/nDDB+vI6BcYtVBY8ui/7Qnv17VZv6cXJS1EuVr4LJvdZ8lY748XjiGD1afyrYaQt3fLCTqvxJBUaFf9/eeoAfOQPKjTz/larCiaFM0zg8TTe/XCroMTNbr9fVdujEWK/Xd6Vqup/a5iZU8AAAALOy/xMNaXyYfb/CP6ihJ7y2gNfgtTVNc//byHk9Xhy794vvF/4YpCp34jL6zBrH5YkhT6qyJ9XlWirY8eFODGxixY5+Fz3vCN4X5xXwmNUDEz9tuVzehTpN3a+lQh8f7JjZXZdsvvs1f1+P++2L91Pj8PgTLL6R5cbtAQBgTkZwMTYYPgQhZy7nBu8PmIu5vKYBefac5+8D2vC+ii6mfp6oVywvdssWH4vVO7lwxwctMXjJVdvosVSgE7tb8129aZq+p/fzjECnk+zRM3EUe252XxmTq9JJVeR0qejxN1XumFnVBZy2wW9LbprCmi5dsmkeKngATE0fF0eldMdTiqlfcKJsnH8Yis49/iZ84vWIUnAuogRN3XVxjqIUnIsYmu9Jyk9TUUPTMrofq27iff8cuWAndVNwkwp29ByxCkhdySnoIeAZia6VOT6oeWT+XNCTCnP8NsWfvhon9QJJvalTwQMgh/9IwxD4AIKp4xwfH/4eTgOvPbShmgNjxnsc5oZzfjxiz1K5yh09blYfayc13k7qZ1zm0S7ZfJVQqopH9/1YPyPR+cWybp/lbsWjaYl4Ivm+AVMVMOfz+a4rttvt1jnsiaVreo6mgMfss99C/2LIveGllgeAiA+qwOP42wo8r6TX0RAVPCXtP7rjuM3j2pHjDLwOry/gdYZ6ffnvp/W9uqpg2pbzQVAu6NHjqUofH/DEsXRil2xxfgU5qQBoqh4NeEYnJoY+uGnqts0HO4+GPf659ZxmVq3Xb0vUtYJHoRDQxRw+sEl8Xcxp38eGDwHAOPBaxVjN5RqA12h/xvLB/1WfA+fymhkbXuPANPBaxtj4YGS1WnUKdySOqxPXl+rKLVe1k5rHhzh+/lz1zliu8ZyH3jC++u4yulYxq1e/pAIaP+3RcXg0lk98ntRPs/pYPaltbJumdeAxJfTF3vRH/ZWhHR/YgDJxoQ/A4z2hP03XfXNp56/s5xDXjHM5HgD6wXsGgK54v/g6XUvHbtni99kqiDD77MpNP+P8PtzJhTd6LBXm+OVj124+3PHbMMJwx+zBzGbyFTyeP+F0oGPlTep+rks3v954Mvvl9Zh+6oTzQZJfV2r9ffMvzLlVApUcdJQQQL0Sf1gBvBvvO8B89XHNV8J7yDPb8NXPESVfL09VCecaAD77aUcAAAh/SURBVES8NwHz5btQa6Pu3HJj7+h+KihKjduTCndiNU6sCEp13zZSD7/xPvNOPcr4S5qqeTQGjx73oY8fnyfO4x+LzxGn+e7bmgKk+MdUL5bc448YaYKJQnHhBwAASsK1LsaIa2oAADA0FSaYfVbltFFhQ/zn9VipE6f7gMff18/Y7VqcNxXujPhzwJcuBJ+p4FnYiEOeeEKlxtwxs7tpOnlyIVBbkNN034vLx8c0Bs+IT1hMDOciAGBMhv6Prjl/ifuufR/6GAPPmvP7BAAMifffvBKur+Z+fN6x/48e51h5Ex+L3bLFAMcv4yuHUtU5ZvdVPzH8GakvH9g+zojRtprohRG7S2sbc0dVO5pX9x8Jdfxyue0yq7+w/PYCAAC0KeGDWFdz/8BWiikchzGd93ifKZzbANCG97rnjfE6guNeljEfjy7nvx8GRb+nxrzx01I/fcVPDHRiuON/j883xtdsQMDzrFh544ObLjeFLbqfC3lS07oEPGb1F4wZAQ8AACljv7Ab8wcBvA7nxePG/l4wBZy3APrG+wreacSVAEjg/aO71HV0qv1iQUKuGidVZROrfWI3bH78nbhMrAqawGv1qZOzrzN79K0oTWPz5Lpki1U9cT25n/G5olz3bELAAwAY+xeYXGRjDDhPx2ns74994fwFxo/XcX+m8reBcwJjwvk6PqmepLrOk+pSLdWFWhyb55Fwxz//3MOdXlbgjL41PV+Rk7qlHvOVOD586RL2+PljpY5HwAMAiCZwQQPwwQ+9G8OXeJz3QHe8Xh4zhvdAj+MLPIfXEPrU9N20Wf47CD9+znK5rI2VE5drGl/HVwPF8Xric41cLy/cvl/9k/uGyQc6saLHPx7H44nLx1DH309V8Fyv17sXUfydgAeYrhL+UHGBCIwbr2HM3Sv+lvK6QqnmfG4Odd08hs/j/BMQ8DVzfk8FzO6/l37k74mqb+KyqS7Z9NOHO3HeWL0zsb9tBDzvpIu32A2bD29iwJMKdfzy0lapk5s2hgtKoIs+PpRxAQagL7yfANOQu77gNQ7hXJiOiX3ZA4wW76vANMSARxU1bRTQSKprNq1f01Lj9HQZs2cCenvDfMU776Ra2kuNz6PfnxmDx+yfsCZVtROf2yPgGaeJvRkBmCk+vAEoHddc79X33wWOH4Ap4hoawBjoOkzvWT7cSV2j3W636rvuGNiID39y02PwkwqHJqLXPwav+ssyuVaXGNT4sXp8F25x3tw0hTqPhjVfWWYIJXQzZVZeGFZKuwDoDx/WAOA9ur7fcr0FAOXi2hkAyhHfk/0YPI9eU/tgxuwzrInr0jy+qzZNj49N0CgCHrOZhDyPVOrkpqXCh7Zu3HSilxZcpEwwZQUAACgaX5zVPxCW1h65a3sAAACMQ2nXl33yAY+Xu2bNdb+m3xXupMbjUfWPHp9w1Y70fuK8+kyc7JEwa67mefRnLqhpGtBqDOEOAABAKSb8H2BI4FoZAAAAY9EUaLw7TOryuakp7EmFO36Z3Ng6hDsFrTSY7BGRGPD4aV8Jd5rG4fEJ6pSTYgAA8GnCF7jAy3CtDADAtHGN/B5cU81P19dWaj7f5VpbuKOfui0Wiym/rl/2QnrXK3SyR8Z7JOCJ03KBjR/MKj7OfyUCAN6J6gcAY8K1MgAA0zfhL4PREwKqx8XP/qk2zH0/0DbmTi7gmbiXnoTvPMOnf6QS4Y2/3xTy5Kp4UsGOHucNCgA+zeCCAADwAK6VASCN62a8C3+LgXFK/Z3o+rfjcrlUlTipsXniumbwN+nlb4Tvfqed/BHzcoFPly7ZukzjvxKB8aDyAQCA9+JaGQDyZvCFGoAWBHDIyRUctAUzWq6pWie37ES95UU2xCt5NkdQmip7fFVPPLmbxuJpehx41IzeWAEAwExwrYy+cc0M9IP3ZwAoW5cKm9T0WLkT1zOza6m3/bEb6q/qrI6m17Ubty74r0T0iQoTAAAwJVwr4xVm9sUEAEwSISPQTJU4cRydnFR4M8NqHe+tbzJDvqPN8uhKW9DTtozZbF8gAAAAQO/4sgcAAAD45zvnLt9Dt1X6zPS767d/qBj6U8wsj3Lku2rz9CJo66oNAABM20wvjIGncK0MAMB8jeH6mWsVlKrL64dAJ2mQF3UJ7ySzP/JNHqnoAQAA08XFMvAYrpUBoCyPXMvwHg4Aw/Hv1/79uOl9nM+rw+UspfzFnP0Z8CgudgAAAAAAAAAAr0R402jwL+kH3wCHM+VBhDxAM/4AAQAwX2O9Vub6BQAAIG+s13hjwvVoZ0WcjEVsRMAZBAAAAAAAAAAASlNUplLUxjiEPAAAAAAAAAAAoBTF5SnFbVBA0AMAAAAAAAAAAIZUZJZS5EYFhDwAAAAAAAAAAODdis5Qit64gKAHAAAAAAAAAAC8Q/H5SfEbGBDyAAAAAAAAAACAVxlNbjKaDXUIeQAAAAAAAAAAQN9GlZmMamMDgh4AAAAAAAAAANCH0eUlo9vggJAHAAAAAAAAAAB81WhzktFueEDQAwAAAAAAAAAAuhp9PjL6HQgIegAAAAAAAAAAQM5kcpHJ7EhA0AMAAAAAAAAAAGRyecjkdigg6AEAAAAAAAAAYL4mm4NMdscSCHsAAAAAAAAAAJiHyecfk9/BBIIeAAAAAAAAAACmaTa5x2x2NIGgBwAAAAAAAACA8Ztl1jHLnQ4IegAAAAAAAAAAGJ9ZZxyz3vmAoAcAAAAAAAAAgPKRbRiN0ITABwAAAAAAAACA4ZFlJNAo3RH4AAAAAAAAAADwHuQXLWigryHsAQAAAAAAAACgP+QVD6LB+kHgAwAAAAAAAABAd+QTT6IBX4PABwAAAAAAAACAT+QRPaNBh0EABAAAAAAAAACYGjKHN6Kxy0cYBAAAAAAAAAAYAhlCwf4fya5BXRabXWsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -14879.61,
    y1: -585.03,
    x2: -14879.61,
    y2: -601.54,
    gradientTransform: "translate(16517.3 1190.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c5d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#737376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1637.95,
    y1: 541.38,
    x2: 1683.81,
    y2: 541.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1635.5,
    y1: 599.23,
    x2: 1635.5,
    y2: 595.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    y1: 595.62,
    y2: 592.08,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1636.31,
    y1: 566.72,
    x2: 1636.31,
    y2: 540.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1635.5,
    y1: 593.52,
    x2: 1635.5,
    y2: 588.89,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1598.57,
    y1: 577.48,
    x2: 1646.72,
    y2: 577.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1651.51,
    y1: 580.37,
    x2: 1673.49,
    y2: 580.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#67686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9d9e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 928.58,
    y1: 571.72,
    x2: 928.58,
    y2: 606.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -313.26,
    y1: 10321.56,
    x2: -313.26,
    y2: 10130.53,
    gradientTransform: "translate(-8734.62 294.7) rotate(-90)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1298.98 10908.88) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -290.29,
    y1: 10127.33,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1296.22 10906.12) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -290.29,
    y1: 10127.35,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1292.82 10902.72) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1288.73 10898.63) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1283.92 10893.82) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1278.53 10888.43) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1272.56 10882.46) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1266.09 10875.99) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1258.96 10868.86) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1251.55 10861.45) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1243.6 10853.51) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1235.42 10845.32) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1226.85 10836.76) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1218.18 10828.08) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1209.39 10819.29) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.57,
    gradientTransform: "translate(1683.6 -9542.95)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1686.36 -9545.7)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1689.76 -9549.1)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1693.85 -9553.19)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1698.66 -9558)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1704.05 -9563.39)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1710.02 -9569.36)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1716.48 -9575.83)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1723.62 -9582.96)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1731.02 -9590.37)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1738.97 -9598.32)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1747.15 -9606.5)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1755.72 -9615.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1764.4 -9623.75)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.55,
    gradientTransform: "translate(1773.19 -9632.54)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -290.29,
    y1: 10127.34,
    x2: -290.29,
    y2: 10324.56,
    gradientTransform: "translate(1781.57 -9640.92)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1253.04 10954.81) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: -336.22,
    y1: 10127.33,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1250.28 10952.06) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -336.22,
    y1: 10127.35,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1246.88 10948.66) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1242.79 10944.57) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1237.98 10939.76) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1232.59 10934.37) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1226.62 10928.4) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1220.15 10921.93) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1213.02 10914.8) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1205.61 10907.39) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1197.67 10899.44) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1189.49 10891.26) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1180.92 10882.69) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1172.24 10874.01) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1163.45 10865.22) rotate(-180)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.57,
    gradientTransform: "translate(1729.54 -9497.01)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1732.29 -9499.77)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1735.69 -9503.17)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1739.78 -9507.26)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1744.59 -9512.07)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1749.98 -9517.46)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1755.95 -9523.43)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1762.42 -9529.9)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1769.55 -9537.03)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1776.96 -9544.43)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1784.91 -9552.38)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1793.09 -9560.56)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1801.66 -9569.13)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1810.34 -9577.81)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.55,
    gradientTransform: "translate(1819.13 -9586.6)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: -336.22,
    y1: 10127.34,
    x2: -336.22,
    y2: 10324.56,
    gradientTransform: "translate(1827.51 -9594.99)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -313.26,
    y1: 10128.94,
    x2: -313.26,
    y2: 10325.09,
    gradientTransform: "translate(1804.54 -9617.95)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 1615,
    y1: 566.03,
    x2: 1615,
    y2: 600.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#909295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#77797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#656769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5b5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 836.27,
    y1: 572.58,
    x2: 836.27,
    y2: 551.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    y1: 552.4,
    y2: 469.11,
    xlinkHref: "#linear-gradient-191"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 280.51,
    y1: 723.11,
    x2: 280.51,
    y2: 522.97,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 280.51,
    y1: 541.49,
    x2: 280.51,
    y2: 711.23,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 280.51,
    y1: 685.46,
    x2: 280.51,
    y2: 562.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 280.51,
    y1: 568.37,
    x2: 280.51,
    y2: 680.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 280.51,
    y1: 569.47,
    x2: 280.51,
    y2: 677.34,
    xlinkHref: "#linear-gradient-194"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 280.51,
    y1: 655.13,
    x2: 280.51,
    y2: 591.33,
    xlinkHref: "#linear-gradient-194"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 280.51,
    y1: 605.96,
    x2: 280.51,
    y2: 642.82,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 280.51,
    y1: 635.02,
    x2: 280.51,
    y2: 612.37,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 423.65,
    y1: 283.48,
    x2: 406.13,
    y2: 283.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 518.04,
    y1: 463.91,
    x2: 518.04,
    y2: 591.98,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1395.01,
    y1: 463.92,
    x2: 1395.01,
    y2: 588.61,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1560.15,
    y1: 463.92,
    x2: 1560.15,
    y2: 588.61,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 873.96,
    y1: 463.92,
    x2: 873.96,
    y2: 588.61,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1039.09,
    y1: 463.92,
    x2: 1039.09,
    y2: 588.61,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 1235.46,
    y1: 723.11,
    x2: 1235.46,
    y2: 522.97,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 1235.46,
    y1: 541.49,
    x2: 1235.46,
    y2: 711.23,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 1235.46,
    y1: 685.46,
    x2: 1235.46,
    y2: 562.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 1235.46,
    x2: 1235.46,
    xlinkHref: "#linear-gradient-194"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 1235.46,
    y1: 569.26,
    x2: 1235.46,
    y2: 676.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 1235.46,
    y1: 643.2,
    x2: 1235.46,
    y2: 603.37,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 1235.46,
    y1: 637.97,
    x2: 1235.46,
    y2: 609.51,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 444.04,
    y1: 564.48,
    x2: 444.04,
    y2: 477.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -9498.51,
    y1: 6023.78,
    x2: -9498.51,
    y2: 5936.58,
    gradientTransform: "translate(-9037.04 6528.35) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -9638.7,
    y1: 6072.63,
    x2: -9638.7,
    y2: 6145.15,
    gradientTransform: "translate(-9272.23 -5423.23) rotate(-116.18)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: -9638.7,
    y1: 6136.83,
    x2: -9638.7,
    y2: 6080.09,
    gradientTransform: "translate(-7111.93 -8003.24) rotate(-99.22)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: -9638.7,
    y1: 6086.24,
    x2: -9638.7,
    y2: 6131.12,
    gradientTransform: "translate(-7111.94 -8003.24) rotate(-99.22)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -9638.7,
    y1: 6125.97,
    x2: -9638.7,
    y2: 6090.85,
    gradientTransform: "translate(-10562.44 3480.37) rotate(-162.61)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 650.58,
    y1: 508.2,
    x2: 650.58,
    y2: 627.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#454446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#444345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#353334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#242021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 569.92,
    y1: 613.31,
    x2: 569.92,
    y2: 634.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 650.58,
    x2: 650.58,
    xlinkHref: "#linear-gradient-212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 731.24,
    x2: 731.24,
    xlinkHref: "#linear-gradient-212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 579.04,
    y1: 514.6,
    x2: 605.12,
    y2: 514.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 592.08,
    y1: 514.88,
    x2: 592.08,
    y2: 496.68,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 168.45,
    y1: 355.38,
    x2: 168.45,
    y2: 235.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 325.83,
    y1: 355.38,
    x2: 325.83,
    y2: 235.82,
    xlinkHref: "#linear-gradient-216"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 212.22,
    y1: 188.73,
    x2: 212.22,
    y2: 516.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 34.61,
    y1: 516.79,
    x2: 34.61,
    y2: 632.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 117.83,
    y1: 559.22,
    x2: 117.83,
    y2: 522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 103.41,
    y1: 622.67,
    x2: 103.41,
    y2: 630.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-14",
    x1: 1602.65,
    y1: 510.85,
    x2: 1602.65,
    y2: 560.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-15",
    x1: 1614.26,
    y1: 602.07,
    x2: 1614.26,
    y2: 620.25,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-16",
    x1: 1601.99,
    y1: 488.28,
    x2: 1601.99,
    y2: 638.34,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: -7544.89,
    y1: 3910.21,
    x2: -7544.89,
    y2: 3929.93,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 1625.05,
    y1: 513.56,
    x2: 1625.05,
    y2: 534.95,
    xlinkHref: "#linear-gradient-106"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 1108.8,
    y1: 489.26,
    x2: 1108.8,
    y2: 581.23,
    gradientTransform: "translate(-116.19 625.33) rotate(-30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#969799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bdbebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#eaebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 1362.12,
    x2: 1362.12,
    gradientTransform: "translate(2277.01 1669.09) rotate(-150)",
    xlinkHref: "#linear-gradient-223"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 1052.25,
    y1: 37.99,
    x2: 1052.25,
    y2: 572.08,
    xlinkHref: "#linear-gradient-111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 244.38,
    y1: 422.05,
    x2: 244.38,
    y2: 404.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 223.5,
    y1: 409.65,
    x2: 223.5,
    y2: 417.28,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 263.67,
    y1: 409.65,
    x2: 263.67,
    y2: 417.28,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 243.58,
    y1: 410.67,
    x2: 243.58,
    y2: 416.16,
    xlinkHref: "#linear-gradient-216"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 90.6,
    y1: 495.23,
    x2: 90.6,
    y2: 507.19,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 8.15,
    y1: 341.72,
    x2: 19.69,
    y2: 375.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: -10088.8,
    y1: 517.16,
    x2: -10088.8,
    y2: 496.31,
    gradientTransform: "translate(11567.78 1012.99) scale(1 -1)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: -10115.56,
    y1: 496.12,
    x2: -10115.56,
    y2: 518.09,
    gradientTransform: "translate(11621.3 1012.99) scale(1 -1)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: -9470.4,
    y1: 517.16,
    x2: -9470.4,
    y2: 496.31,
    gradientTransform: "translate(10330.98 1012.99) scale(1 -1)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: -9497.16,
    y1: 496.12,
    x2: -9497.16,
    y2: 518.09,
    gradientTransform: "translate(10384.5 1012.99) scale(1 -1)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 13.76,
    y1: 239.42,
    x2: 13.76,
    y2: 336.99,
    xlinkHref: "#linear-gradient-231"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-288",
    width: 1291,
    height: 88,
    transform: "translate(1945.67 712.15)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1877.85,579.92h-83.13c-14.42,0-25.79-9.14-40.18-20.7-25.51-20.51-60.45-48.59-139.14-48.59v-4c80.09,0,115.66,28.59,141.64,49.47,13.78,11.07,24.66,19.82,37.68,19.82h83.13c20.8,0,34.75-3.95,42.64-12.09,9.74-10.05,9.28-25.19,8.79-41.21-.69-22.34-1.4-45.44,27.36-53.99,13.29-3.95,22.27,2.58,30.19,8.34,5.89,4.29,11.46,8.34,18.41,8.34h35.15v4h-35.15c-8.25,0-14.61-4.63-20.76-9.1-7.87-5.73-15.3-11.13-26.7-7.75-25.8,7.67-25.17,28.25-24.5,50.04.5,16.15,1.01,32.86-9.91,44.12-8.68,8.95-23.56,13.3-45.51,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1892.28,580.79h-97.56c-14.33,0-25.67-8.17-40.03-18.52-25.54-18.4-60.51-43.61-139.28-43.61v-3.78c80,0,115.54,25.62,141.49,44.32,13.81,9.95,24.71,17.81,37.82,17.81h97.56c21.47,0,34.16-3.15,38.79-9.64,4.62-6.48,1.3-16.14-2.55-27.33-6.7-19.46-15.04-43.69,21.43-58.26,14.41-5.76,23.27-2.3,32.64,1.36,6.5,2.54,13.22,5.17,22.64,5.17h35.15v3.78h-35.15c-10.13,0-17.51-2.88-24.02-5.43-9.03-3.53-16.83-6.58-29.86-1.37-33.12,13.23-26.07,33.71-19.25,53.51,4.02,11.67,7.81,22.68,2.05,30.75-5.46,7.66-18.77,11.22-41.87,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2019.64,589.8h-319.4v-23.76h319.4c6.56,0,11.88,5.32,11.88,11.88h0c0,6.56-5.32,11.88-11.88,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1720.37,599.91h-22.58c-10.81,0-14.63-9.85-14.63-21.99h0c0-12.15,3.82-21.99,14.63-21.99h22.58c10.81,0,42.16,9.85,42.16,21.99h0c0,12.15-31.34,21.99-42.16,21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1745.78,581.93h-104.33c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4h104.33v8.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 1701.48,
    y: 586.19,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 1701.48,
    y: 566.04,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1727.11,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1727.11,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1736.85,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1736.85,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1687.85,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1687.85,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1697.6,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1697.6,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1701.48,
    y: 555.93,
    width: 7.99,
    height: 43.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1832.69,560.88c0-3.66-2.96-6.62-6.62-6.62s-6.62,2.96-6.62,6.62v21.31h13.24v-21.31ZM1823.07,560.25c0-1.65,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1756.37,
    y: 566.04,
    width: 240.36,
    height: 23.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 1756.37,
    y: 569.79,
    width: 240.36,
    height: 16.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1983.96,518.83l-156.87,42.53c-.74.2-1.51-.24-1.71-.98h0c-.2-.74.24-1.51.98-1.71l156.87-42.53c.74-.2,1.51.24,1.71.98h0c.2.74-.24,1.51-.98,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1863.38,556.11h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1862.66,554.46h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1862.32,552.23h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1865.72,555.48h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1865,553.82h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1864.67,551.59h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1868.06,554.84h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1867.34,553.19h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1867.01,550.96h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1870.4,554.21h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1869.68,552.55h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1869.35,550.32h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1872.74,553.58h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1872.02,551.92h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1871.69,549.69h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1875.08,552.94h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1874.36,551.28h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1874.03,549.05h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1877.42,552.31h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1876.7,550.65h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1876.37,548.42h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1879.76,551.67h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1879.05,550.01h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1878.71,547.78h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1882.1,551.04h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1881.39,549.38h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1881.05,547.15h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1884.45,550.4h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1883.73,548.74h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1883.39,546.51h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1886.79,549.77h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1886.07,548.11h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1885.73,545.88h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1889.13,549.13h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1888.41,547.47h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1888.07,545.25h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1891.47,548.5h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1890.75,546.84h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1890.41,544.61h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1893.81,547.86h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1893.09,546.21h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1892.75,543.98h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1896.15,547.23h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1895.43,545.57h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1895.1,543.34h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1898.49,546.59h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1897.77,544.94h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1897.44,542.71h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1900.83,545.96h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1900.11,544.3h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1899.78,542.07h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1903.17,545.33h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1902.45,543.67h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1902.12,541.44h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1905.51,544.69h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1904.79,543.03h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1904.46,540.8h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1907.85,544.06h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1907.14,542.4h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1906.8,540.17h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1910.19,543.42h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1909.48,541.76h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1909.14,539.53h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1912.54,542.79h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1911.82,541.13h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1911.48,538.9h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1914.88,542.15h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1914.16,540.49h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1913.82,538.26h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1917.22,541.52h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1916.5,539.86h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1916.16,537.63h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1919.56,540.88h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1918.84,539.22h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1918.5,537h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1921.9,540.25h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1921.18,538.59h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1920.84,536.36h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1924.24,539.61h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1923.52,537.96h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1923.19,535.73h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1926.58,538.98h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1925.86,537.32h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1925.53,535.09h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1928.92,538.35h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1928.2,536.69h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1927.87,534.46h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1931.26,537.71h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1930.54,536.05h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1930.21,533.82h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1933.6,537.08h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1932.88,535.42h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1932.55,533.19h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1935.94,536.44h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1935.22,534.78h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1934.89,532.55h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1938.28,535.81h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1937.57,534.15h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1937.23,531.92h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1940.63,535.17h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1939.91,533.51h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1939.57,531.28h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1942.97,534.54h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1942.25,532.88h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1941.91,530.65h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1945.31,533.9h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1944.59,532.24h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1944.25,530.01h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1947.65,533.27h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1946.93,531.61h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1946.59,529.38h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1949.99,532.63h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1949.27,530.97h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1948.93,528.75h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 1756.37,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1885.08,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1921.63,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1958.18,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1775.42,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1811.97,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1848.53,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1756.37,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2010.57,
    y: 592.71,
    width: 39.48,
    height: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M2000.52,583.56c-2.44,2.61-2.3,6.72.31,9.16l8.71,8.13c2.61,2.44,6.72,2.3,9.16-.31,2.44-2.61,2.3-6.72-.31-9.16l-8.71-8.13c-2.61-2.44-6.72-2.3-9.16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M2018.15,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.16-2.43-5.77-.28-8.08h0c2.16-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2007.62,585.67c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16s-1.41-3.34-.16-4.67c1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2007.12,586.2c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.12-1.04-.97-1.1-2.6-.13-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2016.12,593.6c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16-1.33-1.25-1.41-3.34-.16-4.67,1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2015.62,594.13c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.13-3.64s2.6-1.1,3.64-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M2018.15,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.16-2.43-5.77-.28-8.08h0c2.16-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2295.33,591.07l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2055.14,
    y: 473.89,
    width: 215.96,
    height: 75.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M1992.72,541.26v5.12l20.43,18.32v17.28l23.52,22.8h12.88l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h209.96l24.45-21.05v-29.01h-305.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M1996.5,538.26v5.12l20.43,18.32v17.28l23.52,22.8h6.42l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h208.68l24.45-21.05v-29.01h-297.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2027.98,572.99c2.73,0,4.94,2.21,4.94,4.94s-2.21,4.94-4.94,4.94-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2027.98,574.07c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2045.35,572.99c2.73,0,4.94,2.21,4.94,4.94s-2.21,4.94-4.94,4.94-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2045.35,574.07c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1985.37,510.45c-3.66,0-6.62,2.96-6.62,6.62s2.96,6.62,6.62,6.62h21.31v-13.24h-21.31ZM1984.75,520.07c-1.65,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1992.72,
    y: 504.64,
    width: 305.03,
    height: 41.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 1992.72,
    y: 510.19,
    width: 305.03,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 2021.74,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 1996.5,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 2029.72,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 2256.54,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2264.52,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 2289.61,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 2170.77,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2170.52,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2170.52,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2262.82,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.81-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2170.52,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2170.52,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2170.52,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2170.52,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2170.52,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M2170.52,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2170.52,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2170.49,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2137.72,587.95c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2129.68,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2148.99,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2170.36,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2170.62,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2191.99,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2203.26,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2211.3,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M2220.52,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2145.36,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2170.36,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2206.52,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M2135.32,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.97-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2170.36,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M2170.49,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2137.72,587.95c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2129.68,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2148.99,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2170.36,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2170.62,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2191.99,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2203.26,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2211.3,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2172.99 641.63 2168.82 641.63 2166.73 645.24 2168.82 648.85 2172.99 648.85 2175.08 645.24 2172.99 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-251",
    cx: 2170.91,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2187.2 633.69 2184.25 636.64 2185.33 640.67 2189.36 641.75 2192.31 638.8 2191.23 634.77 2187.2 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2189.73,636.27c.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2191.64 618.03 2191.64 622.2 2195.25 624.29 2198.86 622.2 2198.86 618.03 2195.25 615.94 2191.64 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2195.25,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2183.7 603.82 2186.65 606.77 2190.68 605.69 2191.76 601.66 2188.81 598.71 2184.78 599.79 2183.7 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2186.29,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2168.04 599.38 2172.22 599.38 2174.3 595.77 2172.22 592.16 2168.04 592.16 2165.96 595.77 2168.04 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2168.08,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2153.83 607.32 2156.78 604.37 2155.7 600.34 2151.68 599.26 2148.73 602.21 2149.8 606.24 2153.83 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2151.31,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2149.4 622.98 2149.4 618.81 2145.79 616.72 2142.17 618.81 2142.17 622.98 2145.79 625.07 2149.4 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2145.79,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2157.33 637.19 2154.38 634.24 2150.35 635.32 2149.27 639.35 2152.22 642.3 2156.25 641.22 2157.33 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2154.75,639.72c-.8.8-2.1.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-177",
    cx: 2170.52,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-72.24 877.86) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-175",
    cx: 2170.52,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M2280.31,582.05c-3.27,1.44-4.77,5.27-3.33,8.54l4.79,10.91c1.44,3.27,5.27,4.77,8.54,3.33,3.27-1.44,4.77-5.27,3.33-8.54l-4.79-10.91c-1.44-3.27-5.27-4.77-8.54-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M2290,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2285.99,586.79c.73,1.67-.03,3.62-1.7,4.35-1.67.73-3.62-.03-4.35-1.7-.73-1.67.03-3.62,1.7-4.35s3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2285.33,587.08c.57,1.3-.02,2.82-1.32,3.4-1.3.57-2.82-.02-3.4-1.32-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2290.67,597.43c.73,1.67-.03,3.62-1.7,4.35s-3.62-.03-4.35-1.7.03-3.62,1.7-4.35c1.67-.73,3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2290,597.72c.57,1.3-.02,2.82-1.32,3.4s-2.82-.02-3.4-1.32c-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M2290,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M2060,581.76c-3.35-1.23-7.09.49-8.32,3.85l-4.11,11.18c-1.23,3.35.49,7.09,3.85,8.32,3.35,1.23,7.09-.49,8.32-3.84l4.11-11.18c1.23-3.35-.49-7.09-3.85-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M2051.68,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2060.81,589.12c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24.63-1.71,2.53-2.59,4.24-1.96,1.71.63,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2060.13,588.87c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2056.8,600.03c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24s2.53-2.59,4.24-1.96c1.71.63,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2056.12,599.78c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M2051.68,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M2463.19,540l-6.29,4.47v49.81l6.29,4.47c2.36,1.67,5.28,2.59,8.3,2.59h155.42c3.01,0,5.94-.91,8.3-2.59l6.29-4.47h0v-49.81h0l-6.29-4.47c-2.35-1.67-5.28-2.59-8.3-2.59h-155.42c-3.02,0-5.94.91-8.3,2.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2524.29,
    y: 477.08,
    width: 49.81,
    height: 184.59,
    transform: "translate(1979.82 3118.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2637.85,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(3188.29 -2093.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2635.27,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(3185.72 -2090.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 2632.09,
    y: 546.48,
    width: 5.98,
    height: 1.96,
    transform: "translate(3182.54 -2087.62) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 2628.26,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(3178.71 -2083.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 2623.76,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(3174.21 -2079.29) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 2618.72,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(3169.17 -2074.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 2613.14,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(3163.58 -2068.67) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 2607.09,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(3157.53 -2062.62) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2600.42,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(3150.86 -2055.95) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 2593.49,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(3143.94 -2049.02) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2586.05,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(3136.5 -2041.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 2578.4,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3128.85 -2033.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 2570.39,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3120.83 -2025.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 2562.27,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3112.72 -2017.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 2554.05,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3104.49 -2009.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2454.56,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(1910.09 3005.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 2457.14,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(1912.67 3007.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 2460.32,
    y: 546.48,
    width: 5.98,
    height: 1.97,
    transform: "translate(1915.85 3010.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 2464.14,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(1919.67 3014.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2468.64,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(1924.17 3019.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 2473.69,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(1929.21 3024.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 2479.27,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(1934.8 3029.72) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 2485.32,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(1940.85 3035.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 2491.99,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(1947.52 3042.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 2498.92,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(1954.45 3049.37) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 2506.35,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(1961.88 3056.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2514.01,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(1969.54 3064.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 2522.02,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(1977.55 3072.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 2530.14,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(1985.67 3080.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2538.36,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(1993.89 3088.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 2546.2,
    y: 545.08,
    width: 5.98,
    height: 4.76,
    transform: "translate(2001.73 3096.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2637.85,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(3232.13 -2049.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 2635.27,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(3229.55 -2046.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 2632.09,
    y: 590.31,
    width: 5.98,
    height: 1.96,
    transform: "translate(3226.37 -2043.78) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 2628.26,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(3222.55 -2039.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 2623.76,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(3218.05 -2035.46) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2618.72,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(3213 -2030.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2613.14,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(3207.42 -2024.83) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 2607.09,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(3201.37 -2018.78) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 2600.42,
    y: 589.35,
    width: 5.98,
    height: 3.88,
    transform: "translate(3194.7 -2012.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 2593.49,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(3187.77 -2005.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 2586.05,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(3180.34 -1997.75) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 2578.4,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3172.68 -1990.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 2570.39,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3164.67 -1982.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 2562.27,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3156.55 -1973.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 2554.05,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3148.33 -1965.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 2454.56,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(1866.26 3048.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 2457.14,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(1868.83 3051.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 2460.32,
    y: 590.31,
    width: 5.98,
    height: 1.97,
    transform: "translate(1872.01 3054.6) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 2464.14,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(1875.84 3058.43) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 2468.64,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(1880.34 3062.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 2473.69,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(1885.38 3067.97) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 2479.27,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(1890.96 3073.55) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 2485.32,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(1897.01 3079.6) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 2491.99,
    y: 589.36,
    width: 5.98,
    height: 3.88,
    transform: "translate(1903.69 3086.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 2498.92,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(1910.61 3093.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 2506.35,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(1918.05 3100.64) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 2514.01,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(1925.7 3108.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 2522.02,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(1933.72 3116.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 2530.14,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(1941.83 3124.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 2538.36,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(1950.06 3132.64) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 2546.2,
    y: 588.91,
    width: 5.98,
    height: 4.76,
    transform: "translate(1957.9 3140.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 2529.21,
    y: 477.08,
    width: 39.96,
    height: 184.59,
    transform: "translate(1979.82 3118.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2457.29,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2462.75,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2468.22,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2473.69,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2480.73,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2487.78,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2494.83,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2501.88,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2508.92,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2517.14,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2525.35,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2533.56,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2541.77,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2635.23,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2629.76,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2624.3,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2618.83,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2611.78,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2604.74,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2597.69,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2590.64,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2583.59,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2575.38,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2567.17,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2558.96,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2550.74,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2641.1,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2635.63,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2630.17,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2624.7,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2617.65,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2610.6,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2603.56,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2596.51,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2589.46,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2581.25,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2573.04,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2564.82,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2556.61,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2463.15,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2468.62,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2474.09,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2479.55,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2486.6,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2493.65,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2500.7,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2507.74,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2514.79,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2523,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2531.22,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2539.43,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2547.64,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2548.43,
    y: 477.08,
    width: 1.52,
    height: 184.59,
    transform: "translate(1979.82 3118.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2548.43,
    y: 494.83,
    width: 1.52,
    height: 184.59,
    transform: "translate(1962.07 3136.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2548.43,
    y: 459.33,
    width: 1.52,
    height: 184.59,
    transform: "translate(1997.56 3100.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 2456.9,
    y: 537.41,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "2918.65 541.26 2918.65 581.99 2942.18 604.79 2967.73 604.79 2977.72 591.32 3144.19 591.32 3154.18 604.79 3179.73 604.79 3203.26 581.99 3203.26 541.26 2918.65 541.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "2689.73 541.26 2689.73 581.99 2713.25 604.79 2738.8 604.79 2748.79 591.32 2915.26 591.32 2925.25 604.79 2950.81 604.79 2974.33 581.99 2974.33 541.26 2689.73 541.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3236.29 546.38 2431.27 546.38 2325.35 494.2 2013.15 494.2 2013.15 473.89 3236.29 473.89 3236.29 546.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2456.79,
    y: 490.87,
    width: 779.5,
    height: 55.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2456.79,
    y: 498.25,
    width: 779.5,
    height: 40.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2965.66,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 2828.51,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M3202.12,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 3064.97,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2914.05,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 2906.14,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 2898.23,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 2890.33,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2882.42,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 2874.51,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 2866.6,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 2858.7,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2850.79,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2842.88,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2834.98,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 2827.07,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 2923.23,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 2963.1,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2927.93,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2928.05,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2965.47,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 2828.51,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M2828.26,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2828.26,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2920.56,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2828.26,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2828.26,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2828.26,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M2828.26,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2828.26,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M2828.26,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2828.26,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M2828.23,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2795.46,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2787.42,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2806.73,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2828.1,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2828.36,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2849.73,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2861,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2869.04,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M2878.27,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2803.1,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2828.1,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2864.26,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M2793.06,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2828.1,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M2828.23,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2795.46,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2787.42,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2806.73,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2828.1,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2828.36,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2849.73,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2861,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2869.04,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2830.74 641.63 2826.56 641.63 2824.48 645.24 2826.56 648.85 2830.74 648.85 2832.82 645.24 2830.74 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-251",
    cx: 2828.65,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2844.94 633.69 2841.99 636.64 2843.07 640.67 2847.1 641.75 2850.05 638.8 2848.97 634.77 2844.94 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2847.47,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2849.38 618.03 2849.38 622.2 2852.99 624.29 2856.61 622.2 2856.61 618.03 2852.99 615.94 2849.38 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2852.99,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2841.45 603.82 2844.4 606.77 2848.43 605.69 2849.51 601.66 2846.56 598.71 2842.53 599.79 2841.45 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2844.03,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2825.79 599.38 2829.96 599.38 2832.04 595.77 2829.96 592.16 2825.79 592.16 2823.7 595.77 2825.79 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2825.83,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2811.58 607.32 2814.53 604.37 2813.45 600.34 2809.42 599.26 2806.47 602.21 2807.55 606.24 2811.58 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2809.05,604.74c-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2807.14 622.98 2807.14 618.81 2803.53 616.72 2799.91 618.81 2799.91 622.98 2803.53 625.07 2807.14 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2803.53,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2815.08 637.19 2812.13 634.24 2808.1 635.32 2807.02 639.35 2809.97 642.3 2814 641.22 2815.08 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M2812.49,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-246",
    cx: 2828.26,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-22.17 1129.56) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 2828.26,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 3065.2,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M3064.96,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM3064.96,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3157.25,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.53-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM3064.96,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3064.96,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM3064.96,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3064.96,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM3064.96,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M3064.96,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM3064.96,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M3064.93,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3032.16,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3024.12,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM3043.43,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM3064.8,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM3065.06,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3086.43,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3097.69,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3105.74,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M3114.96,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM3039.8,595.59c-4.01,4.01-8.97,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3064.8,585.13c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3100.96,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M3029.75,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.97-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM3064.8,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M3064.93,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3032.16,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3024.12,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM3043.43,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM3064.8,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM3065.06,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3086.43,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3097.69,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3105.74,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3067.43 641.63 3063.26 641.63 3061.17 645.24 3063.26 648.85 3067.43 648.85 3069.52 645.24 3067.43 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-251",
    cx: 3065.35,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3081.64 633.69 3078.69 636.64 3079.77 640.67 3083.8 641.75 3086.75 638.8 3085.67 634.77 3081.64 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3084.17,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3086.08 618.03 3086.08 622.2 3089.69 624.29 3093.3 622.2 3093.3 618.03 3089.69 615.94 3086.08 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3089.69,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3078.14 603.82 3081.09 606.77 3085.12 605.69 3086.2 601.66 3083.25 598.71 3079.22 599.79 3078.14 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3080.72,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3062.48 599.38 3066.65 599.38 3068.74 595.77 3066.65 592.16 3062.48 592.16 3060.4 595.77 3062.48 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3062.52,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3048.27 607.32 3051.22 604.37 3050.14 600.34 3046.11 599.26 3043.16 602.21 3044.24 606.24 3048.27 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3045.75,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3043.84 622.98 3043.84 618.81 3040.22 616.72 3036.61 618.81 3036.61 622.98 3040.22 625.07 3043.84 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3040.22,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "3051.77 637.19 3048.82 634.24 3044.79 635.32 3043.71 639.35 3046.66 642.3 3050.69 641.22 3051.77 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M3049.19,639.72c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 3064.96,
    cy: 620.5,
    r: 18.8,
    transform: "translate(1756.87 3460.91) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 3064.96,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3198.49,514.86h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 3210.55,
    y: 600.36,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3204.91,
    y: 479.89,
    width: 11.28,
    height: 156.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M3233.67,540.55h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3234.31,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3234.42,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3232.6,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3232.71,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M3231.41,541.96h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3231,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M3233.67,518.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M3234.83,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3234.42,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M3233.12,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3232.71,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M3231.41,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3231,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M2315.65,689.52c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M2297.96,531.52l-31.92-31.85c-5.06-5.04-11.91-7.88-19.05-7.88h-163.44c-2.94,0-5.33,2.39-5.33,5.33h0c0,2.94,2.39,5.33,5.33,5.33h163.44c4.32,0,8.46,1.71,11.52,4.76l31.92,31.85c3.07,3.06,4.79,7.21,4.79,11.55v22.3h10.66v-22.3c0-7.16-2.85-14.03-7.92-19.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "3169.96 541.26 3162.8 541.26 3162.8 486.41 3180.82 486.41 3169.96 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "3169.96 541.26 3162.8 541.26 3162.8 486.41 3180.82 486.41 3169.96 541.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "2723.66 541.26 2730.81 541.26 2730.81 486.41 2712.8 486.41 2723.66 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "2723.66 541.26 2730.81 541.26 2730.81 486.41 2712.8 486.41 2723.66 541.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M3190.59,695.77c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M3180.82,579.18h-10.66v-22.3c0-4.36-1.7-8.46-4.79-11.55l-31.92-31.85c-3.08-3.07-7.17-4.76-11.52-4.76h-350.24c-4.35,0-8.44,1.69-11.52,4.76l-31.93,31.85c-3.09,3.08-4.79,7.18-4.79,11.55v22.3h-10.66v-22.3c0-7.21,2.81-13.99,7.92-19.09l31.93-31.85c5.09-5.08,11.85-7.88,19.05-7.88h350.24c7.19,0,13.96,2.8,19.05,7.88l31.92,31.85c5.11,5.1,7.92,11.88,7.92,19.09v22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 2013.15,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 2020.05,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 2020.05,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "2024.38 8.79 3229.38 8.79 3229.38 6 2020.05 6 2020.05 468.56 2024.38 468.56 2024.38 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 2618.29,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 2418.17,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2338.51,
    y: 563.56,
    width: 364.13,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 2338.51,
    y: 565.68,
    width: 364.13,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 2338.51,
    y: 568.15,
    width: 364.13,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2338.51,
    y: 605.13,
    width: 364.13,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 2338.51,
    y: 607.24,
    width: 364.13,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 2338.51,
    y: 609.72,
    width: 364.13,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2020.05,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(4080.98 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2021.84,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4061.8 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2022.54,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4047.21 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2023.06,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4047.55 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2025.46,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4053.05 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2025.98,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4053.38 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2028.38,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4058.89 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2028.9,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4059.22 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2031.3,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4064.72 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2031.82,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4065.06 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2034.22,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4070.56 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2034.74,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4070.89 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2037.13,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4076.4 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2037.66,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4076.73 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 2041.02,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4100.15 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2041.72,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4085.56 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2042.24,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4085.89 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2044.64,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4091.4 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2045.16,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4091.73 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2047.55,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4097.23 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2048.07,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4097.57 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2050.47,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4103.07 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2050.99,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4103.4 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2053.39,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4108.91 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2053.91,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4109.24 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2056.31,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4114.74 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2056.83,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4115.08 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 2604.27,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(5249.43 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 2606.07,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5230.26 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2606.77,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5215.67 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2607.29,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5216 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2609.69,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5221.5 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2610.21,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5221.84 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2612.61,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5227.34 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2613.13,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5227.67 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2615.52,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5233.18 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2616.05,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5233.51 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2618.44,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5239.01 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2618.96,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5239.35 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 2621.36,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5244.85 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2621.88,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5245.18 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2625.24,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5268.61 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2625.94,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5254.01 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2626.46,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5254.35 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2628.86,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5259.85 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2629.38,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5260.18 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2631.78,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5265.69 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2632.3,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5266.02 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2634.7,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5271.52 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2635.22,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5271.86 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2637.62,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5277.36 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2638.14,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5277.69 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2640.53,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5283.2 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2641.06,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5283.53 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 3188.5,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(6417.88 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 3190.3,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6398.71 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3191,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6384.12 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3191.52,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6384.45 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3193.91,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6389.95 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3194.44,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6390.29 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3196.83,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6395.79 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3197.35,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6396.13 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3199.75,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6401.63 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3200.27,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6401.96 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3202.67,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6407.46 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3203.19,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6407.8 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 3205.59,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6413.3 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3206.11,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6413.63 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 3209.47,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6437.06 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3210.17,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6422.47 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3210.69,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6422.8 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3213.09,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6428.3 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3213.61,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6428.64 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3216.01,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6434.14 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3216.53,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6434.47 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3218.92,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6439.98 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3219.45,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6440.31 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3221.84,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6445.81 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3222.36,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6446.15 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 3224.76,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6451.65 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3225.28,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6451.98 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-288",
    width: 1656,
    height: 94,
    transform: "translate(-.33 722.15)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 1638.72,
    y: 554.91,
    width: 4.63,
    height: 34.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1633.47,589.03h8.44c1.52,0,2.75,1.23,2.75,2.75v14.07h-13.94v-14.07c0-1.52,1.23-2.75,2.75-2.75Z",
    transform: "translate(3275.37 1194.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1649.78,552.65h-10.67c-.79,0-1.42-.64-1.42-1.42s.64-1.42,1.42-1.42h10.67c3.12,0,6.13-.95,8.68-2.75l23.71-16.68c.64-.46,1.53-.3,1.98.34.45.64.3,1.53-.34,1.98l-23.71,16.68c-3.04,2.14-6.6,3.27-10.32,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1647.12,599.25h-23.25c-1,0-1.8-.81-1.8-1.8h0c0-1,.81-1.8,1.8-1.8h23.25c1,0,1.8.81,1.8,1.8h0c0,1-.81,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1647.12,595.64h-23.25c-1,0-1.8-.81-1.8-1.8h0c0-1,.81-1.8,1.8-1.8h23.25c1,0,1.8.81,1.8,1.8h0c0,1-.81,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1629.63,540.22h13.36c2.41,0,4.36,1.95,4.36,4.36v22.29h-22.08v-22.29c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1644.99,593.55h-18.99c-1.3,0-2.36-1.06-2.36-2.36h0c0-1.3,1.06-2.36,2.36-2.36h18.99c1.3,0,2.36,1.06,2.36,2.36h0c0,1.3-1.06,2.36-2.36,2.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1633.47 587.33 1633.47 567.22 1647.35 567.22 1647.35 564.08 1598.3 564.08 1598.3 590.88 1644.98 590.88 1644.98 587.33 1633.47 587.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1672.24,596.78l-3.02-1.18c-1.63-.64-2.71-2.21-2.71-3.96v-22.07c0-2.04,1.25-3.87,3.15-4.61l2.58-1.01c1.24-.48,1.85-1.88,1.37-3.12-.48-1.24-1.88-1.85-3.12-1.37l-17.08,6.67c-3,1.17-6.2,1.78-9.43,1.78h-9.48v3.47h10.84c1.33,0,2.41,1.08,2.41,2.41v7.31c0,1.33-1.08,2.41-2.41,2.41h-10.84v3.47h10.02c1.78,0,3.22,1.44,3.22,3.23h0c0,1.3.8,2.47,2.01,2.95l20.72,8.09c.29.11.58.17.87.17.96,0,1.87-.58,2.24-1.53.48-1.24-.13-2.63-1.37-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1672.24,596.78l-3.02-1.18c-1.63-.64-2.71-2.21-2.71-3.97v-22.07c0-2.04,1.25-3.87,3.15-4.61l2.58-1.01c1.24-.48,1.85-1.88,1.37-3.12-.48-1.24-1.88-1.85-3.12-1.37l-17.08,6.67c-.66.26-1.34.48-2.02.68v26.98l19.1,7.46c.29.11.58.17.87.17.96,0,1.87-.58,2.24-1.53.48-1.24-.13-2.63-1.37-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1684.15,530.72c-.45-.64-1.34-.8-1.98-.34l-23.71,16.68c-2.55,1.8-5.56,2.75-8.68,2.75h-2.42v-4.92c0-2.57-2.09-4.66-4.66-4.66h-12.76c-2.57,0-4.66,2.09-4.66,4.66v19.2h-26.97v26.8h25.41c-.01.11-.06.2-.06.31,0,.3.07.59.17.86-.97.03-1.75.82-1.75,1.79s.81,1.8,1.8,1.8c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h6.84v3.67c0,1.62,1.32,2.94,2.94,2.94h8.06c1.62,0,2.94-1.32,2.94-2.94v-3.67h2.47c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8c1,0,1.8-.81,1.8-1.8s-.78-1.76-1.75-1.79c.1-.27.17-.55.17-.86,0-1.3-1.06-2.36-2.36-2.36h-.01v-1.5h-11.51v-20.11h13.88v-14.57h2.42c3.71,0,7.28-1.13,10.32-3.27l23.71-16.68c.64-.45.8-1.34.34-1.98ZM1666.74,568.09c.44-1.41,1.5-2.58,2.93-3.14l2.58-1.01c1.24-.48,1.85-1.88,1.37-3.12-.48-1.24-1.88-1.85-3.12-1.37l-17.08,6.67c-3,1.17-6.2,1.78-9.43,1.78h-9.48v3.47h10.84c1.33,0,2.41,1.08,2.41,2.41v7.31c0,1.33-1.08,2.41-2.41,2.41h-10.84v3.47h10.03c1.78,0,3.22,1.44,3.22,3.22,0,1.3.8,2.47,2.01,2.95l20.72,8.09c.29.11.58.17.87.17.96,0,1.87-.58,2.24-1.53.48-1.24-.13-2.63-1.37-3.12l-3.02-1.18c-.17-.07-.31-.18-.47-.27-1.35-.74-2.24-2.13-2.24-3.69v-22.07c0-.51.08-1.01.23-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1610.36,594.41h0c-1.18,0-2.14-.96-2.14-2.14v-29.59c0-1.18.96-2.14,2.14-2.14h0c1.18,0,2.14.96,2.14,2.14v29.59c0,1.18-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M722.85,581.25c-70.79,0-99.33,9.7-120.17,16.78-11.59,3.94-19.97,6.78-32.17,6.78h-177.57c-19.27,0-48.5-43.94-62.41-71.64-1.65-3.3-5.67-4.63-8.96-2.97-3.3,1.65-4.63,5.67-2.98,8.96,4.06,8.09,40.6,79.01,74.35,79.01h177.57c14.41,0,24.64-3.48,36.47-7.5,19.95-6.78,47.28-16.07,115.87-16.07h885.18v-13.36h-885.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 831.74,
    y: 569.47,
    width: 193.68,
    height: 33.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1399.34,577.17l-6.73,4.69v52.2l6.73,4.69c2.52,1.76,5.65,2.71,8.87,2.71h166.16c3.22,0,6.35-.96,8.87-2.71l6.73-4.69h0v-52.2h0l-6.73-4.69c-2.52-1.76-5.64-2.71-8.87-2.71h-166.16c-3.22,0-6.35.96-8.87,2.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 1465.19,
    y: 509.28,
    width: 52.2,
    height: 197.35,
    transform: "translate(883.33 2099.25) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1586.13,
    y: 584.29,
    width: 6.26,
    height: 1.4,
    transform: "translate(2174.25 -1004.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1583.37,
    y: 584.08,
    width: 6.26,
    height: 1.82,
    transform: "translate(2171.5 -1001.52) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1579.97,
    y: 583.94,
    width: 6.26,
    height: 2.1,
    transform: "translate(2168.1 -998.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1575.88,
    y: 583.72,
    width: 6.26,
    height: 2.54,
    transform: "translate(2164.01 -994.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1571.07,
    y: 583.5,
    width: 6.26,
    height: 2.99,
    transform: "translate(2159.2 -989.22) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1565.68,
    y: 583.36,
    width: 6.26,
    height: 3.26,
    transform: "translate(2153.81 -983.83) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1559.71,
    y: 583.14,
    width: 6.26,
    height: 3.7,
    transform: "translate(2147.84 -977.86) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1553.25,
    y: 583.03,
    width: 6.26,
    height: 3.93,
    transform: "translate(2141.37 -971.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1546.11,
    y: 582.92,
    width: 6.26,
    height: 4.15,
    transform: "translate(2134.24 -964.26) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1538.71,
    y: 582.75,
    width: 6.26,
    height: 4.48,
    transform: "translate(2126.83 -956.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1530.76,
    y: 582.67,
    width: 6.26,
    height: 4.64,
    transform: "translate(2118.88 -948.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1522.58,
    y: 582.52,
    width: 6.26,
    height: 4.95,
    transform: "translate(2110.7 -940.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1514.01,
    y: 582.52,
    width: 6.26,
    height: 4.95,
    transform: "translate(2102.13 -932.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1505.33,
    y: 582.41,
    width: 6.26,
    height: 5.17,
    transform: "translate(2093.45 -923.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1496.54,
    y: 582.41,
    width: 6.26,
    height: 5.17,
    transform: "translate(2084.66 -914.68) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1390.18,
    y: 584.29,
    width: 6.26,
    height: 1.4,
    transform: "translate(808.32 1978.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1392.94,
    y: 584.08,
    width: 6.26,
    height: 1.82,
    transform: "translate(811.08 1981.06) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1396.34,
    y: 583.94,
    width: 6.26,
    height: 2.1,
    transform: "translate(814.48 1984.46) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1400.43,
    y: 583.72,
    width: 6.26,
    height: 2.54,
    transform: "translate(818.57 1988.55) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1405.24,
    y: 583.5,
    width: 6.26,
    height: 2.99,
    transform: "translate(823.38 1993.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1410.63,
    y: 583.36,
    width: 6.26,
    height: 3.26,
    transform: "translate(828.77 1998.75) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1416.6,
    y: 583.14,
    width: 6.26,
    height: 3.7,
    transform: "translate(834.74 2004.72) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1423.07,
    y: 583.03,
    width: 6.26,
    height: 3.92,
    transform: "translate(841.21 2011.19) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1430.2,
    y: 582.92,
    width: 6.26,
    height: 4.15,
    transform: "translate(848.34 2018.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1437.6,
    y: 582.75,
    width: 6.26,
    height: 4.48,
    transform: "translate(855.75 2025.73) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1445.55,
    y: 582.67,
    width: 6.26,
    height: 4.64,
    transform: "translate(863.69 2033.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1453.73,
    y: 582.52,
    width: 6.26,
    height: 4.95,
    transform: "translate(871.88 2041.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1462.3,
    y: 582.52,
    width: 6.26,
    height: 4.95,
    transform: "translate(880.44 2050.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1470.98,
    y: 582.41,
    width: 6.26,
    height: 5.17,
    transform: "translate(889.12 2059.1) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 1479.77,
    y: 582.41,
    width: 6.26,
    height: 5.17,
    transform: "translate(897.91 2067.89) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1488.16,
    y: 582.45,
    width: 6.26,
    height: 5.09,
    transform: "translate(906.3 2076.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1586.13,
    y: 630.23,
    width: 6.26,
    height: 1.4,
    transform: "translate(2220.19 -958.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1583.37,
    y: 630.01,
    width: 6.26,
    height: 1.82,
    transform: "translate(2217.43 -955.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1579.97,
    y: 629.88,
    width: 6.26,
    height: 2.1,
    transform: "translate(2214.03 -952.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1575.88,
    y: 629.65,
    width: 6.26,
    height: 2.54,
    transform: "translate(2209.94 -948.09) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1571.07,
    y: 629.43,
    width: 6.26,
    height: 2.99,
    transform: "translate(2205.13 -943.28) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1565.68,
    y: 629.3,
    width: 6.26,
    height: 3.26,
    transform: "translate(2199.74 -937.89) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1559.71,
    y: 629.07,
    width: 6.26,
    height: 3.7,
    transform: "translate(2193.77 -931.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1553.25,
    y: 628.96,
    width: 6.26,
    height: 3.93,
    transform: "translate(2187.3 -925.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1546.11,
    y: 628.85,
    width: 6.26,
    height: 4.15,
    transform: "translate(2180.17 -918.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1538.71,
    y: 628.69,
    width: 6.26,
    height: 4.48,
    transform: "translate(2172.76 -910.91) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1530.76,
    y: 628.6,
    width: 6.26,
    height: 4.64,
    transform: "translate(2164.82 -902.97) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1522.58,
    y: 628.45,
    width: 6.26,
    height: 4.95,
    transform: "translate(2156.64 -894.78) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1514.01,
    y: 628.45,
    width: 6.26,
    height: 4.95,
    transform: "translate(2148.07 -886.21) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1505.33,
    y: 628.34,
    width: 6.26,
    height: 5.17,
    transform: "translate(2139.39 -877.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1496.54,
    y: 628.34,
    width: 6.26,
    height: 5.17,
    transform: "translate(2130.6 -868.75) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1390.18,
    y: 630.23,
    width: 6.26,
    height: 1.4,
    transform: "translate(762.39 2024.24) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1392.94,
    y: 630.01,
    width: 6.26,
    height: 1.82,
    transform: "translate(765.14 2027) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1396.34,
    y: 629.88,
    width: 6.26,
    height: 2.1,
    transform: "translate(768.54 2030.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1400.43,
    y: 629.65,
    width: 6.26,
    height: 2.54,
    transform: "translate(772.63 2034.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1405.24,
    y: 629.43,
    width: 6.26,
    height: 2.99,
    transform: "translate(777.44 2039.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1410.63,
    y: 629.3,
    width: 6.26,
    height: 3.26,
    transform: "translate(782.83 2044.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1416.6,
    y: 629.07,
    width: 6.26,
    height: 3.7,
    transform: "translate(788.8 2050.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1423.07,
    y: 628.96,
    width: 6.26,
    height: 3.92,
    transform: "translate(795.27 2057.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1430.2,
    y: 628.85,
    width: 6.26,
    height: 4.15,
    transform: "translate(802.4 2064.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1437.6,
    y: 628.69,
    width: 6.26,
    height: 4.48,
    transform: "translate(809.81 2071.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1445.55,
    y: 628.6,
    width: 6.26,
    height: 4.64,
    transform: "translate(817.76 2079.61) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1453.73,
    y: 628.45,
    width: 6.26,
    height: 4.95,
    transform: "translate(825.94 2087.79) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1462.3,
    y: 628.45,
    width: 6.26,
    height: 4.95,
    transform: "translate(834.51 2096.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1470.98,
    y: 628.34,
    width: 6.26,
    height: 5.17,
    transform: "translate(843.19 2105.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1479.77,
    y: 628.34,
    width: 6.26,
    height: 5.17,
    transform: "translate(851.98 2113.83) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1488.16,
    y: 628.38,
    width: 6.26,
    height: 5.09,
    transform: "translate(860.36 2122.21) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1470.35,
    y: 509.28,
    width: 41.87,
    height: 197.35,
    transform: "translate(883.33 2099.25) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1411.32,620.86l-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.32c-.16.12-.25.27-.25.42v1.51l2.52-1.81c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l3.06-2.2,2.53,1.82-.12.07,1.25.74.19.14h.02s.02,0,.02,0l3.98-2.35c.4-.24,1.03-.24,1.44,0l2.49,1.47h0l1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.98,2.35,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47,1.48.88,3.98-2.35c.4-.24,1.04-.24,1.44,0l2.49,1.47,1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47h0s1.49.88,1.49.88l1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.98,2.35.04-.02.03.02.31-.22,1.11-.65-.11-.06,2.54-1.83,2.63,1.9h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.53,1.82v-1.51c0-.15-.09-.3-.25-.42l-1.85-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.95,1.4c-.39.28-1.08.3-1.51.05l-2.46-1.45-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-3.98,2.35c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-3.98-2.35-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.44,1.44c-.43.25-1.12.23-1.51-.05l-1.94-1.39-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1411.32,610.75l-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.32c-.16.12-.25.27-.25.42v1.51l2.52-1.81c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l3.06-2.2,2.53,1.82-.12.07,1.25.74.19.14h.02s.02,0,.02,0l3.98-2.35c.4-.24,1.03-.24,1.44,0l2.49,1.47h0l1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.98,2.35,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47,1.48.88,3.98-2.35c.4-.24,1.04-.24,1.44,0l2.49,1.47,1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47h0l1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.98,2.35.04-.02.03.02.31-.22,1.11-.65-.11-.06,2.54-1.83,2.63,1.9h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.53,1.82v-1.51c0-.15-.09-.3-.25-.42l-1.85-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.95,1.4c-.39.28-1.08.3-1.51.05l-2.46-1.45-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-3.98,2.35c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-3.98-2.35-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.44,1.44c-.43.25-1.12.23-1.51-.05l-1.94-1.39-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1411.32,600.64l-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.32c-.16.12-.25.27-.25.42v1.51l2.52-1.81c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l3.06-2.2,2.53,1.82-.12.07,1.25.74.19.14h.02s.02,0,.02,0l3.98-2.35c.4-.24,1.03-.24,1.44,0l2.49,1.47h0l1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.98,2.35,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47,1.48.88,3.98-2.35c.4-.24,1.04-.24,1.44,0l2.49,1.47,1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47h0s1.49.88,1.49.88l1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.98,2.35.04-.02.03.02.31-.22,1.11-.65-.11-.06,2.54-1.83,2.63,1.9h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.53,1.82v-1.51c0-.15-.09-.3-.25-.42l-1.85-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.95,1.4c-.39.28-1.08.3-1.51.05l-2.46-1.45-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-3.98,2.35c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-3.98-2.35-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.44,1.44c-.43.25-1.12.23-1.51-.05l-1.94-1.39-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1411.32,590.53l-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.32c-.16.12-.25.27-.25.42v1.51l2.52-1.81c.42-.3,1.16-.3,1.58,0l1.84,1.33h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l3.06-2.2,2.53,1.82-.12.07,1.25.74.19.14h.02s.02,0,.02,0l3.98-2.35c.4-.24,1.03-.24,1.44,0l2.49,1.47h0l1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.98,2.35,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47,1.48.88,3.98-2.35c.4-.24,1.04-.24,1.44,0l2.49,1.47,1.49.88,1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l2.49,1.47h0s1.49.88,1.49.88l1.49-.88,2.49-1.47c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.26,1.92c.4.24,1.03.24,1.44,0l3.26-1.92c.4-.24,1.03-.24,1.44,0l3.98,2.35.04-.02.03.02.31-.22,1.11-.65-.11-.06,2.54-1.83,2.63,1.9h0l1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l3.06,2.2,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,3.06-2.2c.42-.3,1.16-.3,1.58,0l1.84,1.33,1.22.88,1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l1.84,1.33h0s1.22.88,1.22.88l1.22-.88,1.84-1.33c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.27,1.63c.42.3,1.16.3,1.58,0l2.27-1.63c.42-.3,1.16-.3,1.58,0l2.53,1.82v-1.51c0-.15-.09-.3-.25-.42l-1.85-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-3.06-2.2-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.95,1.4c-.39.28-1.08.3-1.51.05l-2.46-1.45-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-3.98,2.35c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-3.98-2.35-1.49.88-2.49,1.47c-.4.24-1.03.24-1.44,0l-2.49-1.47-1.49-.88-1.49.88-2.44,1.44c-.43.25-1.12.23-1.51-.05l-1.94-1.39-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-1.22.88-1.84,1.33c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88-3.06,2.2c-.42.3-1.16.3-1.58,0l-1.84-1.33-1.22-.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 1392.61,
    y: 574.46,
    width: 197.35,
    height: 40.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M1629.51,582.96c0,8.27-1.49,14.97-3.34,14.97s-3.34-6.7-3.34-14.97,1.49-14.97,3.34-14.97,3.34,6.7,3.34,14.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1603.82,
    y: 565.46,
    width: 22.35,
    height: 34.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 542.09,
    y: 596.36,
    width: 610.79,
    height: 14.09,
    transform: "translate(49.49 -64.08) rotate(4.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M64.51,409.48h324.07c13.6,0,24.64,11.04,24.64,24.64v108.76H64.51v-133.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M340.7,609.97h-106.56c-20.75,0-41.05-4.17-58.71-12.05-13.58-6.06-29.22-9.26-45.23-9.26h-65.69v-20.64h65.69c20.74,0,41.04,4.17,58.71,12.05,13.57,6.06,29.22,9.26,45.23,9.26h106.56c12.9,0,25.85-2.13,37.44-6.17l20.44-7.13c15.05-5.24,31.83-8.02,48.52-8.02h1160.92v20.64H447.1c-12.9,0-25.84,2.14-37.44,6.18l-20.44,7.13c-15.04,5.24-31.82,8.01-48.52,8.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 64.51,
    y: 506.34,
    width: 1543.51,
    height: 66.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 64.51,
    y: 464.55,
    width: 1543.51,
    height: 89.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M280.51,526.33c-53.67,0-97.18,43.51-97.18,97.18s43.51,97.18,97.18,97.18,97.18-43.51,97.18-97.18-43.51-97.18-97.18-97.18ZM280.51,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M379.18,626.4v-5.04h-6.21c-.02-1.01-.04-2.03-.1-3.03l6.18-.54-.44-5.02-6.16.54c-.11-1.01-.24-2.01-.38-3.01l6.11-1.08-.88-4.96-6.08,1.07c-.2-1-.43-1.98-.66-2.96l5.99-1.61-1.3-4.87-5.97,1.6c-.28-.97-.58-1.94-.9-2.9l5.82-2.12-1.72-4.74-5.81,2.11c-.37-.94-.74-1.89-1.14-2.81l5.6-2.61-2.13-4.57-5.6,2.61c-.45-.91-.91-1.81-1.38-2.7l5.36-3.09-2.52-4.36-5.34,3.08c-.53-.86-1.08-1.71-1.64-2.55l5.09-3.56-2.89-4.13-5.07,3.55c-.6-.81-1.22-1.61-1.85-2.4l4.76-4-3.24-3.86-4.75,3.98c-.67-.76-1.35-1.51-2.04-2.24l4.4-4.4-3.56-3.56-4.39,4.39c-.73-.7-1.47-1.39-2.22-2.07l3.99-4.76-3.86-3.24-3.98,4.75c-.79-.63-1.58-1.27-2.39-1.87l3.55-5.07-4.13-2.89-3.54,5.06c-.84-.56-1.69-1.1-2.55-1.64l3.1-5.37-4.36-2.52-3.08,5.34c-.89-.49-1.79-.94-2.69-1.4l2.62-5.62-4.57-2.13-2.61,5.6c-.92-.41-1.86-.79-2.8-1.17l2.12-5.83-4.74-1.72-2.11,5.81c-.96-.32-1.92-.64-2.89-.93l1.6-5.98-4.87-1.3-1.6,5.97c-.98-.24-1.96-.48-2.96-.68l1.07-6.09-4.96-.88-1.07,6.07c-1-.15-2-.26-3.01-.38l.54-6.19-5.02-.44-.54,6.17c-1.01-.06-2.02-.1-3.03-.14v-6.22h-5.04v6.21c-1.01.02-2.03.04-3.03.1l-.54-6.18-5.02.44.54,6.16c-1.01.11-2.01.24-3.01.38l-1.08-6.11-4.96.88,1.07,6.08c-1,.2-1.98.43-2.96.66l-1.61-5.99-4.87,1.3,1.6,5.97c-.97.28-1.94.58-2.9.9l-2.12-5.82-4.74,1.72,2.11,5.81c-.94.37-1.89.74-2.81,1.14l-2.61-5.6-4.57,2.13,2.61,5.6c-.91.45-1.81.91-2.7,1.38l-3.09-5.36-4.36,2.52,3.08,5.34c-.86.53-1.71,1.08-2.55,1.64l-3.56-5.09-4.13,2.89,3.55,5.07c-.81.6-1.61,1.22-2.4,1.85l-4-4.76-3.86,3.24,3.98,4.75c-.76.67-1.51,1.35-2.24,2.04l-4.4-4.4-3.56,3.56,4.39,4.39c-.7.73-1.39,1.47-2.07,2.22l-4.76-3.99-3.24,3.86,4.75,3.98c-.63.79-1.27,1.58-1.87,2.39l-5.07-3.55-2.89,4.13,5.06,3.54c-.56.84-1.1,1.69-1.64,2.55l-5.37-3.1-2.52,4.36,5.34,3.08c-.49.89-.94,1.79-1.4,2.69l-5.62-2.62-2.13,4.57,5.6,2.61c-.41.93-.79,1.86-1.17,2.8l-5.83-2.12-1.72,4.73,5.81,2.11c-.32.96-.64,1.92-.93,2.89l-5.98-1.6-1.3,4.87,5.97,1.6c-.24.98-.48,1.96-.68,2.96l-6.09-1.07-.87,4.96,6.07,1.07c-.15,1-.26,2-.38,3.01l-6.19-.54-.44,5.02,6.17.54c-.06,1.01-.1,2.02-.14,3.03h-6.22v5.04h6.21c.02,1.01.04,2.03.1,3.03l-6.18.54.44,5.02,6.16-.54c.11,1.01.24,2.01.38,3.01l-6.11,1.08.88,4.96,6.08-1.07c.2,1,.43,1.98.66,2.96l-5.99,1.61,1.3,4.87,5.97-1.6c.28.97.58,1.94.9,2.9l-5.82,2.12,1.72,4.74,5.81-2.11c.37.94.74,1.89,1.14,2.81l-5.6,2.61,2.13,4.57,5.6-2.61c.45.91.9,1.81,1.38,2.7l-5.36,3.09,2.52,4.36,5.34-3.08c.53.86,1.08,1.71,1.64,2.55l-5.09,3.56,2.89,4.13,5.07-3.55c.6.81,1.22,1.61,1.85,2.4l-4.76,4,3.24,3.86,4.75-3.98c.67.76,1.35,1.51,2.04,2.24l-4.4,4.4,3.56,3.56,4.39-4.39c.73.7,1.47,1.39,2.22,2.07l-3.99,4.76,3.86,3.24,3.98-4.75c.79.63,1.58,1.27,2.39,1.87l-3.55,5.07,4.13,2.89,3.54-5.06c.84.56,1.69,1.1,2.55,1.64l-3.1,5.37,4.36,2.52,3.08-5.34c.89.49,1.79.94,2.69,1.4l-2.62,5.62,4.57,2.13,2.61-5.6c.92.41,1.86.79,2.8,1.17l-2.12,5.83,4.74,1.72,2.11-5.81c.96.32,1.92.64,2.89.93l-1.6,5.98,4.87,1.3,1.6-5.97c.98.24,1.96.48,2.96.68l-1.07,6.09,4.96.88,1.07-6.07c1,.15,2,.26,3.01.38l-.54,6.19,5.02.44.54-6.17c1.01.06,2.02.1,3.03.14v6.22h5.04v-6.21c1.01-.02,2.03-.04,3.03-.1l.54,6.18,5.02-.44-.54-6.16c1.01-.11,2.01-.24,3.01-.38l1.08,6.11,4.96-.88-1.07-6.08c1-.2,1.98-.43,2.96-.66l1.61,5.99,4.87-1.3-1.6-5.97c.97-.28,1.94-.58,2.9-.9l2.12,5.82,4.73-1.72-2.11-5.81c.94-.37,1.89-.74,2.81-1.14l2.61,5.6,4.57-2.13-2.61-5.6c.91-.45,1.81-.91,2.7-1.38l3.09,5.36,4.36-2.52-3.08-5.34c.86-.53,1.71-1.08,2.55-1.64l3.56,5.09,4.13-2.89-3.55-5.07c.81-.6,1.61-1.22,2.4-1.85l4,4.76,3.86-3.24-3.98-4.75c.76-.67,1.51-1.35,2.24-2.04l4.4,4.4,3.56-3.56-4.39-4.39c.7-.73,1.39-1.47,2.07-2.22l4.76,3.99,3.24-3.86-4.75-3.98c.63-.79,1.27-1.58,1.87-2.39l5.07,3.55,2.89-4.13-5.06-3.54c.56-.84,1.1-1.69,1.64-2.55l5.37,3.1,2.52-4.36-5.34-3.08c.49-.89.94-1.79,1.4-2.69l5.62,2.62,2.13-4.57-5.6-2.61c.41-.93.79-1.86,1.17-2.8l5.83,2.12,1.72-4.73-5.81-2.11c.32-.96.64-1.92.93-2.89l5.98,1.6,1.3-4.87-5.97-1.6c.24-.98.48-1.96.68-2.96l6.09,1.07.87-4.96-6.07-1.07c.15-1,.26-2,.38-3.01l6.19.54.44-5.02-6.17-.54c.06-1.01.1-2.02.14-3.03h6.22ZM280.51,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M280.51,535.45c-48.63,0-88.06,39.42-88.06,88.06s39.42,88.06,88.06,88.06,88.06-39.42,88.06-88.06-39.42-88.06-88.06-88.06ZM280.51,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M280.51,562.05c-33.94,0-61.46,27.51-61.46,61.46s27.51,61.46,61.46,61.46,61.46-27.51,61.46-61.46-27.51-61.46-61.46-61.46ZM280.51,676.83c-29.45,0-53.33-23.88-53.33-53.33s23.88-53.33,53.33-53.33,53.33,23.88,53.33,53.33-23.88,53.33-53.33,53.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M280.51,567.82c-30.76,0-55.69,24.93-55.69,55.69s24.93,55.69,55.69,55.69,55.69-24.93,55.69-55.69-24.93-55.69-55.69-55.69ZM280.51,671.83c-26.69,0-48.32-21.63-48.32-48.32s21.63-48.32,48.32-48.32,48.32,21.63,48.32,48.32-21.63,48.32-48.32,48.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M280.51,571.95c-28.47,0-51.56,23.08-51.56,51.56s23.08,51.56,51.56,51.56,51.56-23.08,51.56-51.56-23.08-51.56-51.56-51.56ZM250.44,653.22c-2.13,1.23-4.86.5-6.09-1.63l-7.75-13.42c-1.23-2.13-.5-4.86,1.63-6.09,2.13-1.23,4.86-.5,6.09,1.63l7.75,13.42c1.23,2.13.5,4.86-1.63,6.09ZM253.57,597.27l-7.75,13.42c-1.23,2.13-3.96,2.86-6.09,1.63-2.13-1.23-2.86-3.96-1.63-6.09l7.75-13.42c1.23-2.13,3.96-2.86,6.09-1.63h0c2.13,1.23,2.86,3.96,1.63,6.09ZM286.75,668.87h-15.49c-2.46,0-4.46-2-4.46-4.46s2-4.46,4.46-4.46h15.49c2.46,0,4.46,2,4.46,4.46s-2,4.46-4.46,4.46ZM289.76,587.07h-15.49c-2.46,0-4.46-2-4.46-4.46s2-4.46,4.46-4.46h15.49c2.46,0,4.46,2,4.46,4.46s-2,4.46-4.46,4.46ZM322.91,640.78l-7.75,13.42c-1.23,2.13-3.96,2.86-6.09,1.63-2.13-1.23-2.86-3.96-1.63-6.09l7.75-13.42c1.23-2.13,3.96-2.86,6.09-1.63,2.13,1.23,2.86,3.96,1.63,6.09ZM322.78,614.93c-2.13,1.23-4.86.5-6.09-1.63l-7.75-13.42c-1.23-2.13-.5-4.86,1.63-6.09h0c2.13-1.23,4.86-.5,6.09,1.63l7.75,13.42c1.23,2.13.5,4.86-1.63,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M280.51,569.47c-29.85,0-54.04,24.19-54.04,54.04s24.19,54.04,54.04,54.04,54.04-24.19,54.04-54.04-24.19-54.04-54.04-54.04ZM248.99,654.66c-2.24,1.29-5.1.52-6.39-1.71l-8.12-14.06c-1.29-2.24-.52-5.1,1.71-6.39,2.24-1.29,5.1-.53,6.39,1.71l8.12,14.06c1.29,2.24.52,5.1-1.71,6.39ZM252.28,596.01l-8.12,14.06c-1.29,2.24-4.15,3-6.39,1.71-2.24-1.29-3-4.15-1.71-6.39l8.12-14.06c1.29-2.24,4.15-3,6.39-1.71h0c2.24,1.29,3,4.15,1.71,6.39ZM287.05,671.05h-16.24c-2.58,0-4.68-2.09-4.68-4.68s2.09-4.68,4.68-4.68h16.24c2.58,0,4.68,2.09,4.68,4.68s-2.09,4.68-4.68,4.68ZM290.21,585.31h-16.24c-2.58,0-4.68-2.09-4.68-4.68s2.09-4.68,4.68-4.68h16.24c2.58,0,4.68,2.09,4.68,4.68s-2.09,4.68-4.68,4.68ZM324.96,641.61l-8.12,14.06c-1.29,2.24-4.15,3-6.39,1.71-2.24-1.29-3-4.15-1.71-6.39l8.12-14.06c1.29-2.24,4.15-3,6.39-1.71,2.24,1.29,3,4.15,1.71,6.39ZM324.82,614.52c-2.24,1.29-5.1.52-6.39-1.71l-8.12-14.06c-1.29-2.24-.52-5.1,1.71-6.39h0c2.24-1.29,5.1-.53,6.39,1.71l8.12,14.06c1.29,2.24.52,5.1-1.71,6.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 280.51,
    cy: 623.51,
    r: 32.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 280.51,
    cy: 623.51,
    r: 20.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "283.15 646.09 278.69 646.09 276.46 649.95 278.69 653.81 283.15 653.81 285.38 649.95 283.15 646.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M283.11,649.95c0,1.21-.98,2.19-2.19,2.19s-2.19-.98-2.19-2.19.98-2.19,2.19-2.19,2.19.98,2.19,2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "298.34 637.6 295.19 640.76 296.34 645.06 300.65 646.22 303.81 643.06 302.65 638.76 298.34 637.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M301.04,640.36c.85.85.85,2.24,0,3.09s-2.24.85-3.09,0c-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "303.09 620.86 303.09 625.32 306.95 627.55 310.81 625.32 310.81 620.86 306.95 618.63 303.09 620.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M306.95,620.9c1.21,0,2.19.98,2.19,2.19s-.98,2.19-2.19,2.19-2.19-.98-2.19-2.19.98-2.19,2.19-2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "294.6 605.67 297.76 608.82 302.06 607.67 303.22 603.36 300.06 600.21 295.76 601.36 294.6 605.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M297.36,602.97c.85-.85,2.24-.85,3.09,0,.85.85.85,2.24,0,3.09-.85.85-2.24.85-3.09,0-.85-.85-.85-2.24,0-3.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "277.86 600.93 282.32 600.93 284.55 597.06 282.32 593.2 277.86 593.2 275.63 597.06 277.86 600.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M277.9,597.06c0-1.21.98-2.19,2.19-2.19s2.19.98,2.19,2.19-.98,2.19-2.19,2.19-2.19-.98-2.19-2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "262.67 609.41 265.82 606.26 264.67 601.95 260.36 600.79 257.21 603.95 258.36 608.26 262.67 609.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M259.97,606.65c-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0,.85.85.85,2.24,0,3.09-.85.85-2.24.85-3.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "257.93 626.15 257.93 621.69 254.06 619.46 250.2 621.69 250.2 626.15 254.06 628.38 257.93 626.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M254.06,626.11c-1.21,0-2.19-.98-2.19-2.19s.98-2.19,2.19-2.19,2.19.98,2.19,2.19-.98,2.19-2.19,2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "266.41 641.34 263.26 638.19 258.95 639.34 257.79 643.65 260.95 646.81 265.26 645.65 266.41 641.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M263.65,644.04c-.85.85-2.24.85-3.09,0-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0,.85.85.85,2.24,0,3.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 280.51,
    cy: 623.51,
    r: 11.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1382.35,596.1l-5.94-11.38c-2.73-5.23-9.18-7.26-14.41-4.53h0c-5.23,2.73-7.26,9.18-4.53,14.41l3.5,6.7h-116.03v-.5h-18.98v.5h-116.02l3.49-6.7c2.73-5.23.7-11.68-4.53-14.41h0c-5.23-2.73-11.68-.7-14.41,4.53l-5.93,11.38c-2.73,5.23-.7,11.68,4.53,14.4h0c4.71,2.46,10.4,1.03,13.47-3.11h26.89v3.05h10.57v3.05h16.75v3.05h18.51v3.05h23.8v3.05h22.88v1.99h18.98v-1.99h22.88v-3.05h23.8v-3.05h18.51v-3.05h16.74v-3.05h10.57v-3.05h26.89c3.08,4.13,8.76,5.57,13.47,3.11h0c5.23-2.73,7.26-9.18,4.53-14.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 1235.73,
    cy: 623.51,
    r: 42.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M413.22,470.66h0c-3.15,0-5.71-2.55-5.71-5.71v-190.5c0-3.15,2.55-5.71,5.71-5.71h0c3.15,0,5.71,2.55,5.71,5.71v190.5c0,3.15-2.55,5.71-5.71,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M425.12,261.63c0-4.86-3.94-8.8-8.8-8.8s-8.8,3.94-8.8,8.8v52.51h17.61v-52.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 511.43,
    y: 464.55,
    width: 13.22,
    height: 127.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1388.41,
    y: 464.55,
    width: 13.22,
    height: 124.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 1553.54,
    y: 464.55,
    width: 13.22,
    height: 124.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 867.35,
    y: 464.55,
    width: 13.22,
    height: 124.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 1032.49,
    y: 464.55,
    width: 13.22,
    height: 124.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1235.46,526.33c-53.67,0-97.18,43.51-97.18,97.18s43.51,97.18,97.18,97.18,97.18-43.51,97.18-97.18-43.51-97.18-97.18-97.18ZM1235.46,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1334.13,626.4v-5.04h-6.21c-.02-1.01-.04-2.03-.1-3.03l6.18-.54-.44-5.02-6.16.54c-.11-1.01-.24-2.01-.38-3.01l6.11-1.08-.88-4.96-6.08,1.07c-.2-1-.43-1.98-.66-2.96l5.99-1.61-1.3-4.87-5.97,1.6c-.28-.97-.58-1.94-.9-2.9l5.82-2.12-1.72-4.74-5.81,2.11c-.37-.94-.74-1.89-1.14-2.81l5.6-2.61-2.13-4.57-5.6,2.61c-.45-.91-.91-1.81-1.38-2.7l5.36-3.09-2.52-4.36-5.34,3.08c-.53-.86-1.08-1.71-1.64-2.55l5.09-3.56-2.89-4.13-5.07,3.55c-.6-.81-1.22-1.61-1.85-2.4l4.76-4-3.24-3.86-4.75,3.98c-.67-.76-1.35-1.51-2.04-2.24l4.4-4.4-3.56-3.56-4.39,4.39c-.73-.7-1.47-1.39-2.22-2.07l3.99-4.76-3.86-3.24-3.98,4.75c-.79-.63-1.58-1.27-2.39-1.87l3.55-5.07-4.13-2.89-3.54,5.06c-.84-.56-1.69-1.1-2.55-1.64l3.1-5.37-4.36-2.52-3.08,5.34c-.89-.49-1.79-.94-2.69-1.4l2.62-5.62-4.57-2.13-2.61,5.6c-.92-.41-1.86-.79-2.8-1.17l2.12-5.83-4.74-1.72-2.11,5.81c-.96-.32-1.92-.64-2.89-.93l1.6-5.98-4.87-1.3-1.6,5.97c-.98-.24-1.96-.48-2.96-.68l1.07-6.09-4.96-.88-1.07,6.07c-1-.15-2-.26-3.01-.38l.54-6.19-5.02-.44-.54,6.17c-1.01-.06-2.02-.1-3.03-.14v-6.22h-5.04v6.21c-1.01.02-2.03.04-3.03.1l-.54-6.18-5.02.44.54,6.16c-1.01.11-2.01.24-3.01.38l-1.08-6.11-4.96.88,1.07,6.08c-1,.2-1.98.43-2.96.66l-1.61-5.99-4.87,1.3,1.6,5.97c-.97.28-1.94.58-2.9.9l-2.12-5.82-4.73,1.72,2.11,5.81c-.94.37-1.89.74-2.81,1.14l-2.61-5.6-4.57,2.13,2.61,5.6c-.91.45-1.81.91-2.7,1.38l-3.09-5.36-4.36,2.52,3.08,5.34c-.86.53-1.71,1.08-2.55,1.64l-3.56-5.09-4.13,2.89,3.55,5.07c-.81.6-1.61,1.22-2.4,1.85l-4-4.76-3.86,3.24,3.98,4.75c-.76.67-1.51,1.35-2.24,2.04l-4.4-4.4-3.56,3.56,4.39,4.39c-.7.73-1.39,1.47-2.07,2.22l-4.76-3.99-3.24,3.86,4.75,3.98c-.63.79-1.27,1.58-1.87,2.39l-5.07-3.55-2.89,4.13,5.06,3.54c-.56.84-1.1,1.69-1.64,2.55l-5.37-3.1-2.52,4.36,5.34,3.08c-.49.89-.94,1.79-1.4,2.69l-5.62-2.62-2.13,4.57,5.6,2.61c-.41.93-.79,1.86-1.17,2.8l-5.83-2.12-1.72,4.73,5.81,2.11c-.32.96-.64,1.92-.93,2.89l-5.98-1.6-1.3,4.87,5.97,1.6c-.24.98-.48,1.96-.68,2.96l-6.09-1.07-.88,4.96,6.07,1.07c-.15,1-.26,2-.38,3.01l-6.19-.54-.44,5.02,6.17.54c-.06,1.01-.1,2.02-.14,3.03h-6.22v5.04h6.21c.02,1.01.04,2.03.1,3.03l-6.18.54.44,5.02,6.16-.54c.11,1.01.24,2.01.38,3.01l-6.11,1.08.87,4.96,6.08-1.07c.2,1,.43,1.98.66,2.96l-5.99,1.61,1.3,4.87,5.97-1.6c.28.97.58,1.94.9,2.9l-5.82,2.12,1.72,4.74,5.81-2.11c.37.94.74,1.89,1.14,2.81l-5.6,2.61,2.13,4.57,5.6-2.61c.45.91.9,1.81,1.38,2.7l-5.36,3.09,2.52,4.36,5.34-3.08c.53.86,1.08,1.71,1.64,2.55l-5.09,3.56,2.89,4.13,5.07-3.55c.6.81,1.22,1.61,1.85,2.4l-4.76,4,3.24,3.86,4.75-3.98c.67.76,1.35,1.51,2.04,2.24l-4.4,4.4,3.56,3.56,4.39-4.39c.73.7,1.47,1.39,2.22,2.07l-3.99,4.76,3.86,3.24,3.98-4.75c.79.63,1.58,1.27,2.39,1.87l-3.55,5.07,4.13,2.89,3.54-5.06c.84.56,1.69,1.1,2.55,1.64l-3.1,5.37,4.36,2.52,3.08-5.34c.89.49,1.79.94,2.69,1.4l-2.62,5.62,4.57,2.13,2.61-5.6c.92.41,1.86.79,2.8,1.17l-2.12,5.83,4.74,1.72,2.11-5.81c.96.32,1.92.64,2.89.93l-1.6,5.98,4.87,1.3,1.6-5.97c.98.24,1.96.48,2.96.68l-1.07,6.09,4.96.88,1.07-6.07c1,.15,2,.26,3.01.38l-.54,6.19,5.02.44.54-6.17c1.01.06,2.02.1,3.03.14v6.22h5.04v-6.21c1.01-.02,2.03-.04,3.03-.1l.54,6.18,5.02-.44-.54-6.16c1.01-.11,2.01-.24,3.01-.38l1.08,6.11,4.96-.88-1.07-6.08c1-.2,1.98-.43,2.96-.66l1.61,5.99,4.87-1.3-1.6-5.97c.97-.28,1.94-.58,2.9-.9l2.12,5.82,4.73-1.72-2.11-5.81c.94-.37,1.89-.74,2.81-1.14l2.61,5.6,4.57-2.13-2.61-5.6c.91-.45,1.81-.91,2.7-1.38l3.09,5.36,4.36-2.52-3.08-5.34c.86-.53,1.71-1.08,2.55-1.64l3.56,5.09,4.13-2.89-3.55-5.07c.81-.6,1.61-1.22,2.4-1.85l4,4.76,3.86-3.24-3.98-4.75c.76-.67,1.51-1.35,2.24-2.04l4.4,4.4,3.56-3.56-4.39-4.39c.7-.73,1.39-1.47,2.07-2.22l4.76,3.99,3.24-3.86-4.75-3.98c.63-.79,1.27-1.58,1.87-2.39l5.07,3.55,2.89-4.13-5.06-3.54c.56-.84,1.1-1.69,1.64-2.55l5.37,3.1,2.52-4.36-5.34-3.08c.49-.89.94-1.79,1.4-2.69l5.62,2.62,2.13-4.57-5.6-2.61c.41-.93.79-1.86,1.17-2.8l5.83,2.12,1.72-4.73-5.81-2.11c.32-.96.64-1.92.93-2.89l5.98,1.6,1.3-4.87-5.97-1.6c.24-.98.48-1.96.68-2.96l6.09,1.07.87-4.96-6.07-1.07c.15-1,.26-2,.38-3.01l6.19.54.44-5.02-6.17-.54c.06-1.01.1-2.02.14-3.03h6.22ZM1235.46,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M1235.46,535.45c-48.63,0-88.06,39.42-88.06,88.06s39.42,88.06,88.06,88.06,88.06-39.42,88.06-88.06-39.42-88.06-88.06-88.06ZM1235.46,673.85c-27.81,0-50.35-22.54-50.35-50.35s22.54-50.35,50.35-50.35,50.35,22.54,50.35,50.35-22.54,50.35-50.35,50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1235.46,562.05c-33.94,0-61.46,27.51-61.46,61.46s27.51,61.46,61.46,61.46,61.46-27.51,61.46-61.46-27.51-61.46-61.46-61.46ZM1235.46,676.83c-29.45,0-53.33-23.88-53.33-53.33s23.88-53.33,53.33-53.33,53.33,23.88,53.33,53.33-23.88,53.33-53.33,53.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1235.46,567.82c-30.76,0-55.69,24.93-55.69,55.69s24.93,55.69,55.69,55.69,55.69-24.93,55.69-55.69-24.93-55.69-55.69-55.69ZM1235.46,671.83c-26.69,0-48.32-21.63-48.32-48.32s21.63-48.32,48.32-48.32,48.32,21.63,48.32,48.32-21.63,48.32-48.32,48.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1235.46,569.47c-29.85,0-54.04,24.19-54.04,54.04s24.19,54.04,54.04,54.04,54.04-24.19,54.04-54.04-24.19-54.04-54.04-54.04ZM1264.13,589.68c3.16-1.83,9.07,2.49,13.2,9.65,4.13,7.15,4.91,14.43,1.75,16.26-3.16,1.83-9.07-2.49-13.2-9.65-4.13-7.15-4.91-14.43-1.75-16.26ZM1206.79,657.33c-3.16,1.83-9.07-2.49-13.2-9.65-4.13-7.15-4.91-14.43-1.75-16.26,3.16-1.83,9.07,2.49,13.2,9.65,4.13,7.15,4.91,14.43,1.75,16.26ZM1205.04,605.94c-4.13,7.15-10.04,11.47-13.2,9.65-3.16-1.83-2.38-9.1,1.75-16.26,4.13-7.15,10.04-11.47,13.2-9.65,3.16,1.83,2.38,9.1-1.75,16.26ZM1235.46,671.86c-8.26,0-14.96-2.96-14.96-6.61s6.7-6.61,14.96-6.61,14.96,2.96,14.96,6.61-6.7,6.61-14.96,6.61ZM1235.46,588.38c-8.26,0-14.96-2.96-14.96-6.61s6.7-6.61,14.96-6.61,14.96,2.96,14.96,6.61-6.7,6.61-14.96,6.61ZM1277.33,647.68c-4.13,7.15-10.04,11.47-13.2,9.65-3.16-1.83-2.38-9.1,1.75-16.26,4.13-7.15,10.04-11.47,13.2-9.65,3.16,1.83,2.38,9.1-1.75,16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M1235.46,569.47c-27.84,0-50.74,21.05-53.7,48.1,2.06,5.7,5.01,10.97,8.67,15.66.32-.78.76-1.43,1.41-1.8,3.16-1.83,9.07,2.49,13.2,9.65,1.42,2.45,2.41,4.91,3.01,7.17,8.14,4.46,17.47,7,27.41,7s19.27-2.54,27.41-7c.6-2.26,1.6-4.71,3.01-7.17,4.13-7.15,10.04-11.47,13.2-9.65.64.37,1.08,1.02,1.41,1.8,3.66-4.69,6.61-9.96,8.67-15.66-2.96-27.05-25.86-48.1-53.7-48.1ZM1205.04,605.94c-4.13,7.15-10.04,11.47-13.2,9.65-3.16-1.83-2.38-9.1,1.75-16.26,4.13-7.15,10.04-11.47,13.2-9.65s2.38,9.1-1.75,16.26ZM1235.46,588.38c-8.26,0-14.96-2.96-14.96-6.61s6.7-6.61,14.96-6.61,14.96,2.96,14.96,6.61-6.7,6.61-14.96,6.61ZM1279.09,615.59c-3.16,1.83-9.07-2.49-13.2-9.65-4.13-7.15-4.91-14.43-1.75-16.26,3.16-1.83,9.07,2.49,13.2,9.65,4.13,7.15,4.91,14.43,1.75,16.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1238.11 646.09 1233.65 646.09 1231.42 649.95 1233.65 653.81 1238.11 653.81 1240.34 649.95 1238.11 646.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1238.06,649.95c0,1.21-.98,2.19-2.19,2.19s-2.19-.98-2.19-2.19.98-2.19,2.19-2.19,2.19.98,2.19,2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1253.3 637.6 1250.14 640.76 1251.3 645.06 1255.61 646.22 1258.76 643.06 1257.61 638.76 1253.3 637.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1256,640.36c.85.85.85,2.24,0,3.09s-2.24.85-3.09,0c-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1258.04 620.86 1258.04 625.32 1261.9 627.55 1265.77 625.32 1265.77 620.86 1261.9 618.63 1258.04 620.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1261.9,620.9c1.21,0,2.19.98,2.19,2.19s-.98,2.19-2.19,2.19-2.19-.98-2.19-2.19.98-2.19,2.19-2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1249.56 605.67 1252.71 608.82 1257.02 607.67 1258.17 603.36 1255.02 600.21 1250.71 601.36 1249.56 605.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1252.32,602.97c.85-.85,2.24-.85,3.09,0,.85.85.85,2.24,0,3.09-.85.85-2.24.85-3.09,0-.85-.85-.85-2.24,0-3.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1232.82 600.93 1237.28 600.93 1239.51 597.06 1237.28 593.2 1232.82 593.2 1230.59 597.06 1232.82 600.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1232.86,597.06c0-1.21.98-2.19,2.19-2.19s2.19.98,2.19,2.19-.98,2.19-2.19,2.19-2.19-.98-2.19-2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1217.62 609.41 1220.78 606.26 1219.62 601.95 1215.32 600.79 1212.16 603.95 1213.32 608.26 1217.62 609.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1214.92,606.65c-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0s.85,2.24,0,3.09-2.24.85-3.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1212.88 626.15 1212.88 621.69 1209.02 619.46 1205.16 621.69 1205.16 626.15 1209.02 628.38 1212.88 626.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1209.02,626.11c-1.21,0-2.19-.98-2.19-2.19s.98-2.19,2.19-2.19,2.19.98,2.19,2.19-.98,2.19-2.19,2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1221.37 641.34 1218.21 638.19 1213.9 639.34 1212.75 643.65 1215.9 646.81 1220.21 645.65 1221.37 641.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1218.6,644.04c-.85.85-2.24.85-3.09,0-.85-.85-.85-2.24,0-3.09.85-.85,2.24-.85,3.09,0s.85,2.24,0,3.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 1235.46,
    cy: 623.51,
    r: 20.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 1235.46,
    cy: 623.51,
    r: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M460.92,518.55h-26.47v-35.75c0-4.29-3.48-7.77-7.77-7.77s-7.77,3.48-7.77,7.77v75.26c0,4.55,3.69,8.24,8.24,8.24h33.76c4.55,0,8.24-3.69,8.24-8.24v-31.27c0-4.55-3.69-8.24-8.24-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M444.59,550.49h26.47v35.75c0,4.29,3.48,7.77,7.77,7.77s7.77-3.48,7.77-7.77v-75.26c0-4.55-3.69-8.24-8.24-8.24h-33.76c-4.55,0-8.24,3.69-8.24,8.24v31.28c0,4.55,3.69,8.24,8.24,8.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 461.47,
    cy: 532.56,
    r: 36.84,
    transform: "translate(-220.04 711.78) rotate(-63.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 461.47,
    cy: 532.56,
    r: 29.7,
    transform: "translate(-138.13 902.76) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 461.47,
    cy: 532.56,
    r: 22.8,
    transform: "translate(-138.13 902.76) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 461.47,
    cy: 532.56,
    r: 18.38,
    transform: "translate(-138.09 162.29) rotate(-17.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 537.77,
    y: 506.49,
    width: 225.62,
    height: 121.36,
    rx: 4.4,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 551.87,
    y: 613,
    width: 36.11,
    height: 21.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 564.58,
    y: 502.22,
    width: 10.68,
    height: 130.76,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M569.92,632.98h0c-1.89,0-3.42-1.53-3.42-3.42v-123.92c0-1.89,1.53-3.42,3.42-3.42h0c1.89,0,3.42,1.53,3.42,3.42v123.92c0,1.89-1.53,3.42-3.42,3.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 632.52,
    y: 613,
    width: 36.11,
    height: 21.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 645.24,
    y: 502.22,
    width: 10.68,
    height: 130.76,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M650.58,632.98h0c-1.89,0-3.42-1.53-3.42-3.42v-123.92c0-1.89,1.53-3.42,3.42-3.42h0c1.89,0,3.42,1.53,3.42,3.42v123.92c0,1.89-1.53,3.42-3.42,3.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 713.18,
    y: 613,
    width: 36.11,
    height: 21.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 725.89,
    y: 502.22,
    width: 10.68,
    height: 130.76,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M731.24,632.98h0c-1.89,0-3.42-1.53-3.42-3.42v-123.92c0-1.89,1.53-3.42,3.42-3.42h0c1.89,0,3.42,1.53,3.42,3.42v123.92c0,1.89-1.53,3.42-3.42,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M579.04,505.91h26.09v7.18c0,5.63-4.57,10.2-10.2,10.2h-5.69c-5.63,0-10.2-4.57-10.2-10.2v-7.18h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 592.08,
    cy: 505.91,
    rx: 13.04,
    ry: 9.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M266.94,294.39c1.86-2.29,2.85-5.29,2.46-8.43l-2.63-21.12c-.76-6.1-6.38-10.48-12.48-9.72l-.37.05c-6.1.76-10.48,6.38-9.72,12.48l2.63,21.12c.39,3.17,2.11,5.85,4.52,7.61-4.47,2.82-7.74,7.49-8.55,13.1l-9.07,62.59c-1.47,10.16,5.64,19.69,15.8,21.16,10.16,1.47,19.69-5.64,21.16-15.8l9.07-62.59c1.32-9.13-4.29-17.73-12.82-20.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M92.03,337.3c-.21,2.05,1.26,3.91,3.25,4.45l25.19,6.85-2.95,10.85c-.4,1.49-1.94,2.36-3.42,1.96h0c-1.01-.28-2.06.32-2.33,1.33l-15.32,56.3,22.88,6.23,15.32-56.3c.28-1.01-.32-2.06-1.33-2.33h0c-1.49-.4-2.36-1.94-1.96-3.42l2.95-10.85,25.19,6.85c1.99.54,4.2-.32,5.05-2.19,1.09-2.39-.24-5.07-2.67-5.73l-64.63-17.59c-2.42-.66-4.93.98-5.21,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M132.26,234.24h115.38c4.21,0,9.19,4.97,9.19,11.11v99.09c0,10.1-6.81,18.93-16.57,21.5l-136.38,35.91c-12.35,3.25-24.28-6.39-23.78-19.15,1.68-42.04,11.6-84.1,33.5-136.99,3.02-7.28,8.85-11.47,18.65-11.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 291.86,
    y: 234.24,
    width: 67.94,
    height: 121.15,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M291.86,325.47v18.05c0,6.55,5.31,11.86,11.86,11.86h44.23c6.55,0,11.86-5.31,11.86-11.86v-18.05h-67.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M145.63,337.91l-6.19,9.42c-3.3,5.02-8.9,8.05-14.91,8.05h-42.15c-1.17,9.18-1.93,18.26-2.29,27.33-.51,12.75,11.43,22.38,23.78,19.13l136.38-35.91c9.77-2.57,16.57-11.4,16.57-21.5v-18.97h-88.14c-9.29,0-17.95,4.68-23.05,12.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1409.5,671.48c-6.49-3.76-24.7-6.95-25.8-36-.81-21.4-.85-49.11-1.11-72.08h-3.3v72.59c0,16.14,1.71,20.27,7.25,32.39,3.7,8.1,11.23,13.2,18.97,9.5l3.79-1.82c1.81-.87,1.94-3.57.2-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M380.96,219.5c-3.21-9.61-14.74-27.56-36.54-30.77-21.79-3.21-221.14,2.56-233.32,8.33-12.18,5.77-79.48,188.44-79.48,220.27,0,40.81-2.99,72.87,2.99,96.16h155.24l5.53-5.13c16.87-15.66,39.03-24.36,62.04-24.36h124.33v-21.57c0-4.14,3.35-7.49,7.49-7.49,2.39,0,4.33-1.94,4.33-4.33v-92.67c0-29.91-9.4-128.84-12.61-138.45ZM256.82,344.44c0,10.1-6.81,18.93-16.57,21.5l-136.38,35.91c-12.35,3.25-24.28-6.39-23.78-19.15,1.68-42.04,11.6-84.1,33.5-136.99,3.02-7.28,8.85-11.47,18.65-11.47h115.38c4.21,0,9.19,4.97,9.19,11.11v99.09ZM359.81,343.53c0,6.55-5.31,11.86-11.86,11.86h-44.23c-6.55,0-11.86-5.31-11.86-11.86v-97.43c0-6.55,5.31-11.86,11.86-11.86h44.23c6.55,0,11.86,5.31,11.86,11.86v97.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.52,421.1c-132.6,0-250.8,19.33-327.62,49.51.03,2.28.08,4.49.16,6.67,76.82-30.14,194.95-49.45,327.46-49.45,11.8,0,23.48.16,35.04.46v-6.73c-11.55-.3-23.23-.46-35.04-.46Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 363,
    height: 87,
    transform: "translate(30.67 427.15)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "178.26 513.49 37.5 513.49 37.5 591.37 72.64 591.37 72.64 633.14 80.98 633.14 80.98 591.37 125.85 591.37 125.85 633.14 134.18 633.14 134.18 591.37 146.64 591.37 178.26 513.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M67.94,633.14H31.41c-16.64,0-30.13-42.26-30.13-58.54v-41.14c0-9.57,8-17.41,17.79-17.41h48.87v117.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "143.5 564.34 72.64 564.34 72.64 521.4 163.02 521.4 143.5 564.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M135.43,559.43h-49.65c-4.4,0-7.96-3.57-7.96-7.96v-30.07h80.04l-15.17,33.36c-1.29,2.84-4.13,4.67-7.25,4.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 70.56,
    y: 626.11,
    width: 65.7,
    height: 7.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 70.56,
    y: 622.59,
    width: 65.7,
    height: 7.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M1588.36,510.56h39.34v51.04h-39.34c-5.94,0-10.76-4.82-10.76-10.76v-29.53c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 1601.99,
    y: 601.97,
    width: 24.53,
    height: 18.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 1595.96,
    y: 487.43,
    width: 12.06,
    height: 152.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1626.71,538.03h0c1.55,0,2.8,1.25,2.8,2.8v14.48c0,1.55-1.25,2.8-2.8,2.8h0c-3.37,0-6.11-2.74-6.11-6.11v-7.86c0-3.37,2.74-6.11,6.11-6.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1627.4,
    y: 539.53,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1627.51,
    y: 539.87,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1625.57,
    y: 539.53,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1625.69,
    y: 539.87,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1623.74,
    y: 539.53,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1623.86,
    y: 539.87,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1626.71,514.06h0c1.55,0,2.8,1.25,2.8,2.8v14.48c0,1.55-1.25,2.8-2.8,2.8h0c-3.37,0-6.11-2.74-6.11-6.11v-7.86c0-3.37,2.74-6.11,6.11-6.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1627.4,
    y: 515.56,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1627.51,
    y: 515.9,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1625.57,
    y: 515.56,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1625.69,
    y: 515.9,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1623.74,
    y: 515.56,
    width: 1.33,
    height: 17.08,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1623.86,
    y: 515.9,
    width: 0.89,
    height: 4.85,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 1101.48,
    y: 473.57,
    width: 14.65,
    height: 111.83,
    transform: "translate(413.29 -483.46) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 1354.79,
    y: 473.57,
    width: 14.65,
    height: 111.83,
    transform: "translate(2806.49 306.98) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 448.89,
    y: 26.45,
    width: 1206.72,
    height: 444.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 455.7,
    y: 32.86,
    width: 1193.1,
    height: 431.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 455.7,
    y: 32.86,
    width: 1193.1,
    height: 431.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "459.97 35.86 1648.8 35.86 1648.8 32.86 455.7 32.86 455.7 464.55 459.97 464.55 459.97 35.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M380.96,219.5c-3.21-9.61-14.74-27.56-36.54-30.77-21.79-3.21-221.14,2.56-233.32,8.33-12.18,5.77-79.48,188.44-79.48,220.27,0,40.81-2.99,72.87,2.99,96.16h155.24l5.53-5.13c16.87-15.66,39.03-24.36,62.04-24.36h124.33v-21.57c0-4.14,3.35-7.49,7.49-7.49,2.39,0,4.33-1.94,4.33-4.33v-92.67c0-29.91-9.4-128.84-12.61-138.45ZM256.82,344.44c0,10.1-6.81,18.93-16.57,21.5l-136.38,35.91c-12.35,3.25-24.28-6.39-23.78-19.15,1.68-42.04,11.6-84.1,33.5-136.99,3.02-7.28,8.85-11.47,18.65-11.47h115.38c4.21,0,9.19,4.97,9.19,11.11v99.09ZM359.81,343.53c0,6.55-5.31,11.86-11.86,11.86h-44.23c-6.55,0-11.86-5.31-11.86-11.86v-97.43c0-6.55,5.31-11.86,11.86-11.86h44.23c6.55,0,11.86,5.31,11.86,11.86v97.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 223.5,
    y: 404.54,
    width: 41.77,
    height: 17.5,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 228.52,
    y: 409.48,
    width: 30.12,
    height: 7.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M229.48,417.11h-8.15c-2.11,0-3.82-1.71-3.82-3.82h0c0-2.11,1.71-3.82,3.82-3.82h8.15v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M257.68,409.48h8.15c2.11,0,3.82,1.71,3.82,3.82h0c0,2.11-1.71,3.82-3.82,3.82h-8.15v-7.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 230.04,
    y: 410.55,
    width: 27.09,
    height: 5.49,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M408.18,528.71c0-27.28-22.12-49.4-49.4-49.4h-111.75c-32.1,0-61.27,18.69-74.68,47.85l-29.77,64.74h7.6c8.63,0,16.46-5.02,20.07-12.86l20.06-43.63c10.19-22.15,32.34-36.35,56.72-36.35h111.76c16.37,0,29.64,13.27,29.64,29.64v48.17c0,8.3,6.73,15.03,15.03,15.03h4.73v-63.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M392.78,519.69v116.3c0,16.14,1.71,20.27,7.25,32.39,3.7,8.1,11.23,13.2,18.97,9.5l3.79-1.82c1.81-.87,1.94-3.57.2-4.57-6.49-3.76-24.7-6.95-25.8-36-1.74-46.06.07-121.32-4.42-115.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M381.99,223.02H125.89c-9.13,0-17.32,5.42-20.86,13.82-11.4,27-37.93,96.72-37.93,160.85v115.8h2.56v-115.8c0-63.66,26.39-133,37.73-159.85,3.14-7.44,10.41-12.25,18.5-12.25h144.55c2.3.77,3.97,2.92,3.97,5.47v232.13c0,10.24-8.33,18.57-18.57,18.57h-6.11v1.92h6.11c11.3,0,20.49-9.19,20.49-20.5v-232.13c0-2.14-.88-4.07-2.28-5.47h107.93c.71,0,1.28-.57,1.28-1.28s-.57-1.28-1.28-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M413.22,526.31c0-28.32-22.96-51.28-51.28-51.28h-115.99c-33.32,0-63.59,19.4-77.51,49.67l-30.9,67.2h7.88c8.95,0,17.09-5.21,20.83-13.35l20.82-45.29c10.57-22.99,33.56-37.73,58.87-37.73h116c16.99,0,30.77,13.77,30.77,30.77v50c0,8.61,6.98,15.6,15.6,15.6h4.91v-65.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M81.17,494h18.86c.9,0,1.64.73,1.64,1.64v10.49c0,.9-.73,1.64-1.64,1.64h-18.86c-.9,0-1.64-.73-1.64-1.64v-10.49c0-.9.73-1.64,1.64-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M83.07,495h15.06c1.29,0,2.33,1.04,2.33,2.33v7.1c0,1.29-1.04,2.33-2.33,2.33h-15.06c-1.29,0-2.33-1.04-2.33-2.33v-7.1c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 97.38,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.59,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 94.21,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.41,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 91.03,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.24,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 87.85,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.06,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 84.68,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.88,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 81.5,
    y: 496.12,
    width: 2.32,
    height: 9.52,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.71,
    y: 496.3,
    width: 1.54,
    height: 2.71,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M30.95,462.64h0c-.27,20.04.11,37.01,3.66,50.85h9.51v-37.68c0-7.27-5.9-13.17-13.17-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M45.4,475.81c0-7.97-6.48-14.45-14.45-14.45-.71,0-1.28.57-1.28,1.28s.57,1.28,1.28,1.28c6.56,0,11.89,5.33,11.89,11.89v37.68h2.56v-37.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M42.52,420.57c0-22.59,30.83-117.62,54.53-178.57,1.46-3.75-1.31-7.77-5.33-7.77h-.24c-24.1,56.56-59.86,159.89-59.86,183.09,0,2.9-.02,5.75-.04,8.56h5.66c2.91,0,5.28-2.36,5.28-5.27v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M98.98,403.77c-4.53,0-8.94-1.53-12.59-4.47-5.07-4.07-7.83-10.14-7.57-16.65,1.72-43.08,12.08-85.46,33.6-137.43,3.37-8.13,10.04-12.26,19.84-12.26h115.38c4.84,0,10.47,5.41,10.47,12.39v99.1c0,10.67-7.21,20.02-17.53,22.74l-136.37,35.9c-1.73.46-3.49.68-5.22.68ZM132.26,235.52c-8.78,0-14.49,3.49-17.47,10.68-21.4,51.68-31.7,93.8-33.41,136.55-.23,5.69,2.19,10.99,6.62,14.55,4.41,3.54,10.08,4.74,15.55,3.31l136.37-35.9c9.2-2.42,15.62-10.75,15.62-20.26v-99.1c0-5.29-4.35-9.83-7.91-9.83h-115.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M347.95,356.67h-44.23c-7.25,0-13.14-5.89-13.14-13.14v-97.43c0-7.25,5.89-13.14,13.14-13.14h44.23c7.25,0,13.14,5.89,13.14,13.14v97.43c0,7.25-5.89,13.14-13.14,13.14ZM303.72,235.52c-5.83,0-10.58,4.74-10.58,10.58v97.43c0,5.83,4.74,10.58,10.58,10.58h44.23c5.83,0,10.58-4.74,10.58-10.58v-97.43c0-5.83-4.74-10.58-10.58-10.58h-44.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M37.24,427.17h-5.66c-.71,0-1.28-.57-1.28-1.28s.57-1.28,1.28-1.28h5.66c2.2,0,4-1.79,4-3.99,0-23.62,32.35-121.83,54.62-179.08.54-1.38.37-2.87-.47-4.09-.84-1.23-2.18-1.93-3.67-1.93-.71,0-1.4-.57-1.4-1.28s.45-1.28,1.16-1.28c2.56,0,4.72,1.14,6.02,3.05,1.3,1.9,1.58,4.32.74,6.47-25.18,64.73-54.44,156.63-54.44,178.1,0,3.66-2.94,6.6-6.56,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M17.89,376.73c-.43.12-.89.18-1.36.15-1.94-.12-3.3-1.65-3.03-3.41,2.23-14.61-7.32-25.72-7.42-25.83-1.17-1.34-.85-3.35.71-4.5,1.57-1.16,3.78-1,4.96.33.47.53,11.41,13.15,8.77,30.45-.2,1.34-1.29,2.42-2.64,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M8.22,344.49c-.46-.52-1.1-.81-1.79-.96-1.19,1.17-1.41,2.9-.35,4.11.1.11,4.13,8.29,7.42,25.83.3,1.59.88,2.94,2.53,3.28.5-.5.85-1.12.96-1.81,2.64-17.3-8.3-29.92-8.77-30.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M137.06,226.97h-4.97c-1.03,0-1.91.62-2.31,1.5H25.61c-14.12,0-25.61,11.49-25.61,25.61v103.48c0,10.5,6.29,19.82,16.03,23.75l70.43,28.4c.03,1.39,1.16,2.51,2.55,2.51h4.97c1.42,0,2.56-1.15,2.56-2.56s-1.15-2.56-2.56-2.56h-4.97c-.47,0-.88.16-1.26.38l-70.77-28.53c-5.6-2.26-9.91-6.5-12.31-11.73l8.47-3.41c.68-.27,1-1.04.73-1.72-.27-.68-1.04-1-1.72-.73l-8.44,3.4c-.74-2.28-1.16-4.69-1.16-7.18v-67.22h13.66c.71,0,1.28-.57,1.28-1.28s-.57-1.28-1.28-1.28H2.56v-33.69c0-12.71,10.34-23.04,23.04-23.04h104.46c.47.63,1.18,1.07,2.03,1.07h4.97c1.42,0,2.56-1.15,2.56-2.56s-1.15-2.56-2.56-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1467.43,492.78h49.85c1.99,0,3.6,1.61,3.6,3.6v20.21c0,1.99-1.61,3.6-3.6,3.6h-49.85c-1.99,0-3.6-1.61-3.6-3.6v-20.21c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2984.72 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 1466.34,
    y: 495.68,
    width: 25.29,
    height: 21.62,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2957.96 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1467.31,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2937.59 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1468.04,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2938.06 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1471.38,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2945.74 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1472.11,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2946.2 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1475.46,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2953.88 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1476.18,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2954.35 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1479.53,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2962.03 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1480.26,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2962.49 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1483.6,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2970.17 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1484.33,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2970.64 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1487.68,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2978.32 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1488.4,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2978.79 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1493.09,
    y: 495.68,
    width: 25.29,
    height: 21.62,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(3011.48 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1494.07,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2991.11 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1494.8,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2991.58 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1498.14,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2999.26 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1498.87,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2999.72 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1502.22,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3007.4 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1502.94,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3007.87 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1506.29,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3015.55 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1507.02,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3016.01 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1510.36,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3023.69 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1511.09,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3024.16 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1514.44,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3031.84 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1515.16,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3032.3 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M849.03,492.78h49.85c1.99,0,3.6,1.61,3.6,3.6v20.21c0,1.99-1.61,3.6-3.6,3.6h-49.85c-1.99,0-3.6-1.61-3.6-3.6v-20.21c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(1747.91 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 847.93,
    y: 495.68,
    width: 25.29,
    height: 21.62,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1721.15 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 848.91,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1700.79 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 849.64,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1701.26 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 852.98,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1708.93 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 853.71,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1709.4 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 857.06,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1717.08 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 857.78,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1717.55 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 861.13,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1725.23 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 861.86,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1725.69 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 865.2,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1733.37 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 865.93,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1733.84 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 869.27,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1741.52 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 870,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1741.98 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 874.69,
    y: 495.68,
    width: 25.29,
    height: 21.62,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1774.67 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 875.67,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1754.31 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 876.4,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1754.77 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 879.74,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1762.45 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 880.47,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1762.92 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 883.82,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1770.6 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 884.54,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1771.07 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 887.89,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1778.75 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 888.62,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1779.21 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 891.96,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1786.89 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 892.69,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1787.36 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 896.03,
    y: 497.75,
    width: 2.97,
    height: 17.5,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1795.04 1012.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 896.76,
    y: 498.09,
    width: 1.98,
    height: 4.97,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1795.5 1001.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-266",
    cx: 16.88,
    cy: 288.08,
    rx: 6.52,
    ry: 44.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M17.12,242.61h1.62v90.95h-1.62c-4.61,0-8.34-3.74-8.34-8.34v-74.26c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M8.77,251.45h.33c1.8,0,3.25,1.46,3.25,3.25v66.76c0,1.8-1.46,3.25-3.25,3.25h-.33v-73.27h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5AxSingleSingleTandem);
export default __webpack_public_path__ + "static/media/5-Ax Single-Single-Tandem.452ea84f4ed3fe6251f2677e249d191e.svg";
export { ForwardRef as ReactComponent };